
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("6m4LV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $lqsSp = parcelRequire("lqsSp");


var $caX7N = parcelRequire("caX7N");


var $gdv5Z = parcelRequire("gdv5Z");


var $g5lKx = parcelRequire("g5lKx");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");


var $oZBat = parcelRequire("oZBat");


var $fRJCL = parcelRequire("fRJCL");


var $4dNEc = parcelRequire("4dNEc");


var $2205s = parcelRequire("2205s");


var $2TEGg = parcelRequire("2TEGg");

const $df640aaa5edb6adc$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
function $df640aaa5edb6adc$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48FEk.InternalEntryPointContainer), {
        id: $df640aaa5edb6adc$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2205s.CardLoading), null),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId
        }
    });
}
function $df640aaa5edb6adc$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df640aaa5edb6adc$var$UserProfileCardForMentionInner, props));
}
/** Inner implementation of {@link UserProfileCardForMention}. */ function $df640aaa5edb6adc$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', testId: testId }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $42omo.useCallback)(()=>{
        (0, $fRJCL.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $42omo.useCallback)((_props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $irOoi.loadEntryPoint)(environmentProvider, (0, $oZBat.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        environmentProvider
    ]);
    // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    if (!referenceElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2TEGg.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        placement: placement,
        testId: testId,
        shouldRenderToParent: true
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        onError: onErrorBoundary,
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: (0, $g5lKx.layers).modal()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lqsSp.Popper), {
        referenceElement: referenceElement,
        placement: placement
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            ref: ref,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- positioning controlled by popper
            style: style,
            testId: testId ? `${testId}--mention-popup` : undefined
        }, entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($df640aaa5edb6adc$var$PopperContent, {
            entryPointReference: entryPointReference,
            entryPointErrorFallback: entryPointErrorFallback,
            cloudId: cloudId,
            testId: testId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2205s.CardLoading), null))))));
}
module.exports["UserProfileCardForMention"] = $df640aaa5edb6adc$export$b3a703a1f8ebb0c8;

});

parcelRegister("oZBat", function(module, exports) {

var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


var $li1Tx = parcelRequire("li1Tx");


var $3Gey6 = parcelRequire("3Gey6");

const $482a141e4af62e04$var$fetchPolicy = 'store-or-network';

const $482a141e4af62e04$export$6333901e831d7af0 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("4G9a0")), {
        moduleId: "0e8b22f8",
        moduleName: "UserProfileCardEntryPoint",
        priority: "interaction",
        moduleId: 'user-profile-card-entrypoint'
    }),
    getPreloadProps: ({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId })=>{
        const variables = (0, $li1Tx.buildQueryVariables)({
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        });
        return {
            queries: {
                queryRef: {
                    parameters: $3Gey6.default,
                    variables: variables,
                    options: {
                        fetchPolicy: $482a141e4af62e04$var$fetchPolicy
                    }
                }
            }
        };
    }
});
module.exports["entryPoint"] = $482a141e4af62e04$export$6333901e831d7af0;

});

parcelRegister("li1Tx", function(module, exports) {

var $a1w2U = parcelRequire("a1w2U");


var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $4dNEc = parcelRequire("4dNEc");


var $kGcl2 = parcelRequire("kGcl2");


var $7rc4d = parcelRequire("7rc4d");

/**
 * Renders a user profile card from a Relay fragment.
 *
 * The fragment is colocated: it contains the user's base profile (name, avatar,
 * email, extendedProfile) and the supplemental data (manager, third-party
 * integrations, recent work) in one spread, so everything fetches in a single
 * round-trip.
 *
 * Recent-work previews need a `SmartCardProvider` from `@atlaskit/link-provider`
 * in scope. Atlassian product shells provide this by default.
 *
 * @example
 * ```tsx
 * const data = useLazyLoadQuery<MyQuery>(
 *   graphql`
 *     query MyQuery($userId: ID!, $cloudId: String!, $orgId: String!, $viewerId: String!) {
 *       ...UserProfileCardRelay_query @arguments(
 *         userId: $userId, cloudId: $cloudId, orgId: $orgId, viewerId: $viewerId
 *       )
 *     }
 *   `,
 *   buildQueryVariables({ userId, cloudId, orgId, viewerId }),
 * );
 * return <UserProfileCardRelay queryFragment={data} cloudId={cloudId} />;
 * ```
 */ function $30359ad292ebe595$export$8d4b90914bf8e85e({ queryFragment: queryFragment, cloudId: cloudId, testId: testId, isLoading: isLoading }) {
    const data = (0, $irOoi.useFragment)((0, $a1w2U.default), queryFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($30359ad292ebe595$var$UserProfileCardRelayContent, {
        data: data,
        cloudId: cloudId,
        testId: testId,
        isLoading: isLoading
    });
}
function $30359ad292ebe595$var$UserProfileCardRelayContent({ data: data, cloudId: cloudId, testId: testId, isLoading: isLoading }) {
    const user = data.user;
    const accountId = user?.accountId ?? '';
    const rawSingleUser = data.knowledgeDiscovery?.singleUser;
    const knowledgeSingleUser = rawSingleUser && 'user' in rawSingleUser ? rawSingleUser : null;
    const rawManager = knowledgeSingleUser?.user?.manager;
    const recentWorkData = (0, $42omo.useMemo)(()=>{
        const edges = data.activity?.workedOn?.edges ?? [];
        const urls = edges.flatMap((edge)=>{
            const objectData = edge?.node?.object?.data;
            if (!objectData) return [];
            switch(objectData.__typename){
                case 'ConfluencePage':
                case 'ConfluenceBlogPost':
                case 'ConfluenceWhiteboard':
                case 'ConfluenceInlineComment':
                case 'ConfluenceFooterComment':
                    return objectData.links?.base && objectData.links?.webUi ? [
                        `${objectData.links.base}${objectData.links.webUi}`
                    ] : [];
                case 'JiraIssue':
                case 'JiraPlatformComment':
                case 'JiraServiceManagementComment':
                    return objectData.webUrl ? [
                        objectData.webUrl
                    ] : [];
                case 'ExternalDocument':
                    return objectData.url ? [
                        objectData.url
                    ] : [];
                case 'BitbucketPullRequest':
                    return objectData.href ? [
                        objectData.href
                    ] : [];
                case 'LoomVideo':
                    return objectData.loomUrl ? [
                        objectData.loomUrl
                    ] : [];
                default:
                    return [];
            }
        });
        return urls.length ? urls : undefined;
    }, [
        data.activity?.workedOn?.edges
    ]);
    const profileData = (0, $42omo.useMemo)(()=>{
        if (!user) return null;
        const knowledge = knowledgeSingleUser?.user;
        const manager = rawManager?.id ? {
            id: rawManager.id,
            name: rawManager.name,
            avatarUrl: rawManager.picture,
            jobTitle: rawManager.jobTitle
        } : null;
        const thirdPartyIntegrations = knowledge?.thirdPartyIntegrations?.filter((integration)=>Boolean(integration?.externalId && integration?.integrationId && integration?.product)).map((integration)=>({
                externalId: integration.externalId,
                integrationId: integration.integrationId,
                product: integration.product
            }));
        return {
            accountId: user.accountId,
            name: user.name ?? '',
            avatarUrl: user.picture,
            email: user.email,
            jobTitle: user.extendedProfile?.jobTitle,
            department: user.extendedProfile?.department,
            location: user.extendedProfile?.location,
            organization: user.extendedProfile?.organization,
            manager: manager,
            thirdPartyIntegrations: thirdPartyIntegrations?.length ? thirdPartyIntegrations : null
        };
    }, [
        user,
        knowledgeSingleUser,
        rawManager
    ]);
    if (!accountId || !profileData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGcl2.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rc4d.UserProfileCard), {
        cloudId: cloudId,
        testId: testId,
        isLoading: isLoading,
        profileData: profileData,
        recentWorkData: recentWorkData
    }));
}
function $30359ad292ebe595$export$9a3cee82e7cc08ff({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId }) {
    return {
        userId: userId,
        userIdString: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        userAri: `ari:cloud:identity::user/${userId}`
    };
}
module.exports["UserProfileCardRelay"] = $30359ad292ebe595$export$8d4b90914bf8e85e;
module.exports["buildQueryVariables"] = $30359ad292ebe595$export$9a3cee82e7cc08ff;

});

parcelRegister("a1w2U", function(module, exports) {
/**
 * @generated SignedSource<<13edc718c517087b128dda4856a554bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5b4c1c775549c8b5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v2 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v5 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v4 /*: any*/ 
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "userIdString"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "viewerId"
            }
        ],
        "kind": "Fragment",
        "name": "UserProfileCardRelay_query",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "accountId",
                        "variableName": "userId"
                    }
                ],
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "email"
                            },
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": [
                                    v2 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "department"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "location"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "organization"
                                    }
                                ]
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    }
                ]
            },
            {
                "concreteType": "Activity",
                "kind": "LinkedField",
                "name": "activity",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "fields": [
                                    {
                                        "items": [
                                            {
                                                "kind": "Variable",
                                                "name": "actors.0",
                                                "variableName": "userAri"
                                            }
                                        ],
                                        "kind": "ListValue",
                                        "name": "actors"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "filter"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                            }
                        ],
                        "concreteType": "ActivityConnection",
                        "kind": "LinkedField",
                        "name": "workedOn",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ActivityItemEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "ActivityNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "ActivityObject",
                                                "kind": "LinkedField",
                                                "name": "object",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "data",
                                                        "plural": false,
                                                        "selections": [
                                                            v3 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "ConfluencePageLinks",
                                                                        "kind": "LinkedField",
                                                                        "name": "links",
                                                                        "plural": false,
                                                                        "selections": v4 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "ConfluencePage"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "ConfluenceBlogPostLinks",
                                                                        "kind": "LinkedField",
                                                                        "name": "links",
                                                                        "plural": false,
                                                                        "selections": v4 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "ConfluenceBlogPost"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "ConfluenceWhiteboardLinks",
                                                                        "kind": "LinkedField",
                                                                        "name": "links",
                                                                        "plural": false,
                                                                        "selections": v4 /*: any*/ 
                                                                    }
                                                                ],
                                                                "type": "ConfluenceWhiteboard"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v5 /*: any*/ ,
                                                                "type": "ConfluenceInlineComment"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v5 /*: any*/ ,
                                                                "type": "ConfluenceFooterComment"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v6 /*: any*/ ,
                                                                "type": "JiraIssue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v6 /*: any*/ ,
                                                                "type": "JiraPlatformComment"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v6 /*: any*/ ,
                                                                "type": "JiraServiceManagementComment"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "url"
                                                                    }
                                                                ],
                                                                "type": "ExternalDocument"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "href"
                                                                    }
                                                                ],
                                                                "type": "BitbucketPullRequest"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "alias": "loomUrl",
                                                                        "kind": "ScalarField",
                                                                        "name": "url"
                                                                    }
                                                                ],
                                                                "type": "LoomVideo"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "KnowledgeDiscoveryQueryApi",
                "kind": "LinkedField",
                "name": "knowledgeDiscovery",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "accountId",
                                "variableName": "userIdString"
                            },
                            {
                                "kind": "Variable",
                                "name": "orgId",
                                "variableName": "orgId"
                            },
                            {
                                "kind": "Variable",
                                "name": "requestingUserId",
                                "variableName": "viewerId"
                            },
                            {
                                "kind": "Variable",
                                "name": "tenantId",
                                "variableName": "cloudId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "singleUser",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "concreteType": "KnowledgeDiscoveryUserProfile",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "KnowledgeDiscoveryUserManager",
                                                "kind": "LinkedField",
                                                "name": "manager",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    v2 /*: any*/ ,
                                                    v1 /*: any*/ ,
                                                    v0 /*: any*/ 
                                                ]
                                            },
                                            {
                                                "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                "kind": "LinkedField",
                                                "name": "thirdPartyIntegrations",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "externalId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "integrationId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "product"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "type": "KnowledgeDiscoverySingleUser"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$5b4c1c775549c8b5$var$node.hash = "01530ebfa8ea71e38aa3dd685cea064c";
var $5b4c1c775549c8b5$export$2e2bcd8739ae039 = $5b4c1c775549c8b5$var$node;
module.exports["default"] = $5b4c1c775549c8b5$export$2e2bcd8739ae039;

});

parcelRegister("4dNEc", function(module, exports) {
/* CardError.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $kGcl2 = parcelRequire("kGcl2");

const $ffa90fd44525fb29$var$messages = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "user-profile-card.error.title",
        defaultMessage: "Something went wrong and we couldn't load this profile."
    },
    errorDescription: {
        id: "user-profile-card.error.description",
        defaultMessage: "Try again in a few moments."
    }
});
const $ffa90fd44525fb29$var$styles = {
    body: "_ca0q1ejb _n3td1ejb _19bv1ejb _u5f31ejb _y3gn1h6o"
}; /**
    * Error fallback when the entry point fails to render or profile data is missing.
    */ 
function $ffa90fd44525fb29$export$f7f7efdefcc02999({ testId: testId }) {
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGcl2.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: testId,
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        xcss: $ffa90fd44525fb29$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "semibold",
        color: "color.text.subtlest"
    }, intl.formatMessage($ffa90fd44525fb29$var$messages.errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, intl.formatMessage($ffa90fd44525fb29$var$messages.errorDescription)))));
}
module.exports["CardError"] = $ffa90fd44525fb29$export$f7f7efdefcc02999;

});

parcelRegister("kGcl2", function(module, exports) {
/* CardPopupWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $373dad8f5d7298cd$var$styles = {
    wrapper: "_2rko1mok _1reo15vq _18m915vq _1bsb1gwv _16qs1nax"
};
function $373dad8f5d7298cd$export$aefd550f0f72fff8({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $373dad8f5d7298cd$var$styles.wrapper,
        backgroundColor: "elevation.surface.overlay"
    }, children);
}
module.exports["CardPopupWrapper"] = $373dad8f5d7298cd$export$aefd550f0f72fff8;

});

parcelRegister("7rc4d", function(module, exports) {
/* UserProfileCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $esRft = parcelRequire("esRft");


var $cO1el = parcelRequire("cO1el");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $O1c6O = parcelRequire("O1c6O");

var $fDXXi = parcelRequire("fDXXi");


var $6er8q = parcelRequire("6er8q");


var $e8zaz = parcelRequire("e8zaz");


var $8en9F = parcelRequire("8en9F");


var $ikcEb = parcelRequire("ikcEb");


var $cptht = parcelRequire("cptht");


var $4dNEc = parcelRequire("4dNEc");


var $84vSp = parcelRequire("84vSp");


var $2205s = parcelRequire("2205s");


var $2CZ7b = parcelRequire("2CZ7b");


var $3rynt = parcelRequire("3rynt");


var $5QyNZ = parcelRequire("5QyNZ");

const $4cba81a0340423db$var$styles = {
    root: "_1bsb1gwv _1ul95x59 _80om73ad _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhkhp5a"
}; /**
    * Presentational profile card displaying a user's core information and recent work.
    * Renders avatar, name, pronouns, job title, department, location, manager, and recent-work items.
    *
    * Shows a loading skeleton when `isLoading` is true or `profileData` is undefined.
    * Displays an error state when profile data is missing or `name` is not provided.
    *
    * Recent-work previews require a `SmartCardProvider` from `@atlaskit/link-provider`
    * in scope (already provided by every Atlassian product shell).
    */ 
function $4cba81a0340423db$export$7bf40cd2a197df2d({ profileData: profileData, recentWorkData: recentWorkData, isLoading: isLoading = false, testId: testId = 'user-profile-card', cloudId: cloudId, error: error }) {
    const outerContext = (0, $42omo.useContext)((0, $ikcEb.UserProfileCardContext));
    const userId = profileData?.accountId ?? '';
    const localGetTestId = (0, $42omo.useMemo)(()=>(0, $cptht.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]); // Forward outer values so trigger-wrapped + standalone consumers see the same shape;
    // fall back to a local getTestId factory when there is no outer provider.
    const contextValue = (0, $42omo.useMemo)(()=>({
            ...outerContext,
            cloudId: cloudId,
            getTestId: outerContext.getTestId !== (0, $ikcEb.defaultGetTestId) ? outerContext.getTestId : localGetTestId
        }), [
        cloudId,
        localGetTestId,
        outerContext
    ]);
    const analyticsData = {
        source: 'userProfileCard',
        attributes: {
            cloudId: cloudId,
            userId: userId,
            hasManager: Boolean(profileData?.manager),
            hasRecentWork: Boolean(recentWorkData?.length),
            hasThirdPartyIntegrations: Boolean(profileData?.thirdPartyIntegrations?.length)
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $O1c6O.TeamsAppAnalyticsContext), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ikcEb.UserProfileCardContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8en9F.CardOpenTimerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4cba81a0340423db$var$UserProfileCardErrorBoundary, {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4cba81a0340423db$var$UserProfileCardContent, {
        profileData: profileData,
        recentWorkData: recentWorkData,
        isLoading: isLoading,
        testId: testId,
        cloudId: cloudId,
        error: error
    })))));
}
function $4cba81a0340423db$var$UserProfileCardErrorBoundary({ children: children, testId: testId }) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const handleError = (0, $42omo.useCallback)((_error)=>{
        // `default` (not `renderError`) - schema only allows `default | NotFound`.
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $6er8q.firedAt)(),
            errorType: 'default',
            hasRetry: false
        });
    }, [
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        onError: handleError,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
            testId: testId
        })
    }, children);
}
function $4cba81a0340423db$var$UserProfileCardContent({ profileData: profileData, recentWorkData: recentWorkData, isLoading: isLoading, testId: testId, cloudId: cloudId, error: error }) {
    const { getTestId: getTestId } = (0, $42omo.useContext)((0, $ikcEb.UserProfileCardContext));
    const hasProfileData = Boolean(profileData && profileData.name);
    (0, $e8zaz.useFireRequestSucceeded)(!isLoading && hasProfileData);
    (0, $e8zaz.useFireRequestFailed)(!isLoading && !hasProfileData ? error ?? null : undefined);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2205s.CardLoading), {
        testId: testId
    });
    if (!profileData || !profileData.name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $84vSp.CardErrorState), {
        testId: testId,
        errorType: "NotFound"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4cba81a0340423db$var$UserProfileCardRenderedContent, {
        profileData: profileData,
        recentWorkData: recentWorkData,
        testId: testId,
        cloudId: cloudId,
        getTestId: getTestId
    });
} // Success-only render. Split out so `useFireContentRendered` mounts (and fires)
// only when the user actually sees the content - not on loading or error.
function $4cba81a0340423db$var$UserProfileCardRenderedContent({ profileData: profileData, recentWorkData: recentWorkData, testId: testId, cloudId: cloudId, getTestId: getTestId }) {
    (0, $e8zaz.useFireContentRendered)(profileData);
    const { name: name, pronouns: pronouns, avatarUrl: avatarUrl, jobTitle: jobTitle, department: department, location: location, localTime: localTime, manager: manager } = profileData;
    const subtitleParts = [
        jobTitle,
        department
    ].filter(Boolean);
    const subtitle = subtitleParts.join(` \u2022 `);
    const locationLine = localTime && location ? `${location} \u2013 ${localTime}` : location ?? undefined;
    const hasRecentWork = Boolean(recentWorkData?.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $4cba81a0340423db$var$styles.root,
        testId: testId,
        role: "region",
        "aria-label": name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200",
        testId: "profilecard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarUrl ?? undefined,
        name: name,
        size: "xlarge",
        testId: getTestId('avatar')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2CZ7b.HeaderActions), {
        profileData: profileData,
        cloudId: cloudId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h2",
        size: "medium",
        testId: getTestId('name')
    }, name), pronouns && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest",
        testId: getTestId('pronouns')
    }, pronouns)), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 2,
        color: "color.text.subtlest",
        testId: getTestId('subtitle')
    }, subtitle), locationLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 2,
        size: "small",
        color: "color.text.subtlest",
        testId: getTestId('location')
    }, locationLine))), manager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3rynt.ManagerSection), {
        manager: manager,
        testId: getTestId('manager')
    }), hasRecentWork && recentWorkData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5QyNZ.RecentWorkSection), {
        recentWorkData: recentWorkData,
        testId: getTestId('recent-work')
    })));
}
module.exports["UserProfileCard"] = $4cba81a0340423db$export$7bf40cd2a197df2d;

});

parcelRegister("6er8q", function(module, exports) {

var $fRJCL = parcelRequire("fRJCL");

function $a3affc9488ff134f$export$935a1f551ec13075(profileData) {
    if (!profileData) return 0;
    let count = 0;
    if (profileData.accountId) count += 1;
    if (profileData.thirdPartyIntegrations && profileData.thirdPartyIntegrations.length > 0) count += 1;
    return count;
}
const $a3affc9488ff134f$export$feb180212387929b = ()=>Math.round((0, $fRJCL.getPageTime)());
const $a3affc9488ff134f$export$6ad9e7706a4ee0f8 = (error)=>{
    const statusCode = $a3affc9488ff134f$var$readNumericField(error, 'statusCode') ?? $a3affc9488ff134f$var$readNumericField(error, 'status') ?? $a3affc9488ff134f$var$readRelayExtensionsStatusCode(error);
    if (statusCode === 404 || $a3affc9488ff134f$var$isNotFoundLikeError(error, statusCode)) return statusCode !== undefined ? {
        errorType: 'NotFound',
        statusCode: statusCode
    } : {
        errorType: 'NotFound'
    };
    return statusCode !== undefined ? {
        errorType: 'default',
        statusCode: statusCode
    } : {
        errorType: 'default'
    };
};
/**
 * Relay surfaces network errors as `{ errors: [{ extensions: { statusCode, errorType, ... } }] }`.
 * Reads the first error's `extensions.statusCode` so the SLO classification works against the
 * common Relay error envelope, not just hand-rolled `{ statusCode }` objects.
 */ const $a3affc9488ff134f$var$readRelayExtensionsStatusCode = (error)=>{
    if (!error || typeof error !== 'object' || !('errors' in error)) return undefined;
    const errors = error.errors;
    if (!Array.isArray(errors) || errors.length === 0) return undefined;
    const first = errors[0];
    if (!first || typeof first !== 'object' || !('extensions' in first)) return undefined;
    const extensions = first.extensions;
    if (!extensions || typeof extensions !== 'object') return undefined;
    return $a3affc9488ff134f$var$readNumericField(extensions, 'statusCode') ?? $a3affc9488ff134f$var$readNumericField(extensions, 'status');
};
const $a3affc9488ff134f$var$readNumericField = (error, field)=>{
    if (error && typeof error === 'object' && field in error) {
        const value = error[field];
        if (typeof value === 'number' && Number.isFinite(value)) return value;
    }
    return undefined;
};
/** Returns true for unambiguous not-found signals. Message-pattern matching is last-resort — only used when statusCode is absent to avoid misclassifying generic errors (e.g. a 500 whose message contains "not found"). */ const $a3affc9488ff134f$var$isNotFoundLikeError = (error, statusCode)=>{
    if (!error || typeof error !== 'object') return false;
    const code = $a3affc9488ff134f$var$readStringField(error, 'code');
    if (code && /NOT_FOUND/i.test(code)) return true;
    // Only match message patterns when there is no statusCode — a 500 with "not found" in its message must not be misclassified as NotFound.
    if (statusCode === undefined) {
        const message = $a3affc9488ff134f$var$readStringField(error, 'message');
        if (message && /\bnot\s*found\b/i.test(message)) return true;
    }
    return false;
};
const $a3affc9488ff134f$var$readStringField = (error, field)=>{
    if (field in error) {
        const value = error[field];
        if (typeof value === 'string') return value;
    }
    return undefined;
};
module.exports["countRenderedActions"] = $a3affc9488ff134f$export$935a1f551ec13075;
module.exports["firedAt"] = $a3affc9488ff134f$export$feb180212387929b;
module.exports["getErrorAttributes"] = $a3affc9488ff134f$export$6ad9e7706a4ee0f8;

});

parcelRegister("fRJCL", function(module, exports) {
const $fc9bc55d1493f9f0$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $fc9bc55d1493f9f0$var$performanceAvailable = $fc9bc55d1493f9f0$var$isPerformanceAvailable();
const $fc9bc55d1493f9f0$var$initialPageTime = Date.now();
const $fc9bc55d1493f9f0$export$e9faea7c41053334 = ()=>{
    if ($fc9bc55d1493f9f0$var$performanceAvailable) return performance.now();
    return Date.now() - $fc9bc55d1493f9f0$var$initialPageTime;
};
module.exports["getPageTime"] = $fc9bc55d1493f9f0$export$e9faea7c41053334;

});

parcelRegister("e8zaz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $6er8q = parcelRequire("6er8q");


var $8en9F = parcelRequire("8en9F");

// Cast payload superset to `never` so `fireEvent` accepts extra SLO fields.
const $6fdfc7a6d3326b98$var$asExtendedPayload = (payload)=>payload;
function $6fdfc7a6d3326b98$export$97ec6f6769110fe4() {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    return ()=>{
        fireEvent('operational.profilecard.triggered.request', {
            firedAt: (0, $6er8q.firedAt)()
        });
    };
}
function $6fdfc7a6d3326b98$export$f7831696c122c106() {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const firedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.spinner', {
            firedAt: (0, $6er8q.firedAt)()
        });
    }, [
        fireEvent
    ]);
}
function $6fdfc7a6d3326b98$export$38eb2c63ddf3e3a3(hasProfileData) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const firedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasProfileData || firedRef.current) return;
        firedRef.current = true;
        fireEvent('operational.profilecard.succeeded.request', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0
        });
    }, [
        hasProfileData,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $6fdfc7a6d3326b98$export$20c24f03e0a7c8fc(profileData) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const firedRef = (0, $42omo.useRef)(false);
    const profileDataRef = (0, $42omo.useRef)(profileData);
    profileDataRef.current = profileData;
    (0, $42omo.useEffect)(()=>{
        if (firedRef.current) return;
        firedRef.current = true;
        fireEvent('ui.profilecard.rendered.content', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            numActions: (0, $6er8q.countRenderedActions)(profileDataRef.current)
        });
    }, [
        fireEvent,
        getDurationSinceInteraction
    ]);
}
function $6fdfc7a6d3326b98$export$5fc91356da713d06(error) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const firedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (error === undefined || firedRef.current) return;
        firedRef.current = true;
        const attributes = error === null ? {
            errorType: 'NotFound'
        } : (0, $6er8q.getErrorAttributes)(error);
        if (attributes.errorType === 'NotFound') {
            fireEvent('operational.profilecard.succeeded.request', {
                firedAt: (0, $6er8q.firedAt)(),
                duration: getDurationSinceInteraction() ?? 0
            });
            return;
        }
        fireEvent('operational.profilecard.failed.request', $6fdfc7a6d3326b98$var$asExtendedPayload({
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            // schema requires `errorMessage`; send the classified type to avoid PII.
            errorMessage: attributes.errorType,
            errorType: attributes.errorType,
            ...attributes.statusCode !== undefined ? {
                errorStatusCode: attributes.statusCode
            } : {}
        }));
    }, [
        error,
        fireEvent,
        getDurationSinceInteraction
    ]);
}
module.exports["useFireTriggeredRequest"] = $6fdfc7a6d3326b98$export$97ec6f6769110fe4;
module.exports["useFireRenderedSpinner"] = $6fdfc7a6d3326b98$export$f7831696c122c106;
module.exports["useFireRequestSucceeded"] = $6fdfc7a6d3326b98$export$38eb2c63ddf3e3a3;
module.exports["useFireContentRendered"] = $6fdfc7a6d3326b98$export$20c24f03e0a7c8fc;
module.exports["useFireRequestFailed"] = $6fdfc7a6d3326b98$export$5fc91356da713d06;

});

parcelRegister("8en9F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fRJCL = parcelRequire("fRJCL");

const $ecfee26886c7524c$var$noopContext = {
    markInteractionStart: ()=>{},
    getDurationSinceInteraction: ()=>undefined
};
const $ecfee26886c7524c$var$CardOpenTimerContext = /*#__PURE__*/ (0, $42omo.createContext)($ecfee26886c7524c$var$noopContext);
function $ecfee26886c7524c$export$8f61ff484d9ed897({ children: children }) {
    const outer = (0, $42omo.useContext)($ecfee26886c7524c$var$CardOpenTimerContext);
    const interactionStartRef = (0, $42omo.useRef)(null);
    const markInteractionStart = (0, $42omo.useCallback)(()=>{
        // Re-arm per interaction so successive opens each measure from their own t=0.
        interactionStartRef.current = (0, $fRJCL.getPageTime)();
    }, []);
    const getDurationSinceInteraction = (0, $42omo.useCallback)(()=>{
        if (interactionStartRef.current === null) return undefined;
        return Math.max(0, (0, $fRJCL.getPageTime)() - interactionStartRef.current);
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            markInteractionStart: markInteractionStart,
            getDurationSinceInteraction: getDurationSinceInteraction
        }), [
        markInteractionStart,
        getDurationSinceInteraction
    ]);
    if (outer !== $ecfee26886c7524c$var$noopContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ecfee26886c7524c$var$CardOpenTimerContext.Provider, {
        value: value
    }, children);
}
function $ecfee26886c7524c$export$d0c3a3e820a371d6() {
    return (0, $42omo.useContext)($ecfee26886c7524c$var$CardOpenTimerContext);
}
module.exports["CardOpenTimerProvider"] = $ecfee26886c7524c$export$8f61ff484d9ed897;
module.exports["useCardOpenTimer"] = $ecfee26886c7524c$export$d0c3a3e820a371d6;

});

parcelRegister("ikcEb", function(module, exports) {

var $42omo = parcelRequire("42omo");

/** Sentinel identity used to detect "no outer provider" without an explicit flag. */ const $833045f18b03491e$export$ff993edec5f1dba3 = ()=>undefined;
const $833045f18b03491e$export$24fd9e960a1a443b = /*#__PURE__*/ (0, $42omo.createContext)({
    cloudId: '',
    townsquareApp: undefined,
    onProfileClick: undefined,
    getTestId: $833045f18b03491e$export$ff993edec5f1dba3
});
module.exports["defaultGetTestId"] = $833045f18b03491e$export$ff993edec5f1dba3;
module.exports["UserProfileCardContext"] = $833045f18b03491e$export$24fd9e960a1a443b;

});

parcelRegister("cptht", function(module, exports) {
/**
 * Default testId used by the user profile card when the consumer does not pass one.
 * Centralised so the `getTestId` factory in `UserProfileCard` and
 * `UserProfileCardWithTrigger` agrees on what counts as "default".
 */ const $dbc7f2b779db36c7$export$d0c64eda5f53987e = 'user-profile-card';
const $dbc7f2b779db36c7$export$51b2da6fcb5ae549 = (userId, testId)=>{
    const baseTestId = `user-profile-card-${userId}`;
    const isDefaultTestId = !testId || testId === $dbc7f2b779db36c7$export$d0c64eda5f53987e;
    const suffixModifier = isDefaultTestId ? '' : `--${testId}`;
    return (suffix)=>userId ? `${baseTestId}-${suffix}${suffixModifier}` : undefined;
};
module.exports["makeGetTestId"] = $dbc7f2b779db36c7$export$51b2da6fcb5ae549;

});

parcelRegister("84vSp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $6er8q = parcelRequire("6er8q");


var $4dNEc = parcelRequire("4dNEc");

function $3bc9bd20d6342f7c$export$2ebec9f03312245c({ testId: testId, errorType: errorType }) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        fireEvent('ui.profilecard.rendered.error', {
            firedAt: (0, $6er8q.firedAt)(),
            errorType: errorType,
            hasRetry: false
        });
    }, [
        fireEvent,
        errorType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
        testId: testId
    });
}
module.exports["CardErrorState"] = $3bc9bd20d6342f7c$export$2ebec9f03312245c;

});

parcelRegister("2205s", function(module, exports) {
/* CardLoading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $e8zaz = parcelRequire("e8zaz");


var $kGcl2 = parcelRequire("kGcl2");

const $4749f8e69ede5bc2$var$styles = {
    inner: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    fill: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    row: "_n7zl1qm6 _ca0qutpp _n3tdutpp"
};
function $4749f8e69ede5bc2$var$SkeletonRow() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center",
        xcss: $4749f8e69ede5bc2$var$styles.row
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "48px",
        height: "48px",
        borderRadius: "var(--ds-radius-full, 9999px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        xcss: $4749f8e69ede5bc2$var$styles.fill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "40%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "70%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })));
} // Loading state. Fires `rendered.spinner` on mount so the event only emits
function $4749f8e69ede5bc2$export$5d25853fd6bdf402({ testId: testId }) {
    (0, $e8zaz.useFireRenderedSpinner)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGcl2.CardPopupWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: testId,
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        xcss: $4749f8e69ede5bc2$var$styles.inner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "72px",
        height: "72px",
        borderRadius: "var(--ds-radius-full, 9999px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        xcss: $4749f8e69ede5bc2$var$styles.fill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "35%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "65%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4749f8e69ede5bc2$var$SkeletonRow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4749f8e69ede5bc2$var$SkeletonRow, null))));
}
module.exports["CardLoading"] = $4749f8e69ede5bc2$export$5d25853fd6bdf402;

});

parcelRegister("2CZ7b", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7p4As = parcelRequire("7p4As");

var $dE1p6 = parcelRequire("dE1p6");


var $u9agA = parcelRequire("u9agA");


var $fDXXi = parcelRequire("fDXXi");


var $6er8q = parcelRequire("6er8q");


var $9jVmo = parcelRequire("9jVmo");


var $8SquK = parcelRequire("8SquK");


var $8en9F = parcelRequire("8en9F");


var $ikcEb = parcelRequire("ikcEb");


var $dMSD4 = parcelRequire("dMSD4");


var $3exdj = parcelRequire("3exdj");

const $dd80962e40f8ea2d$var$messages = (0, $aXWIB.defineMessages)({
    viewProfile: {
        id: "user-profile-card.action-bar.view-profile",
        defaultMessage: "View profile"
    },
    viewOrgChartLabel: {
        id: "user-profile-card.action-bar.view-org-chart-label",
        defaultMessage: "View org chart for {name}"
    },
    sendMessageLabel: {
        id: "user-profile-card.action-bar.send-message-label",
        defaultMessage: "Send message to {name}"
    }
});
function $dd80962e40f8ea2d$export$223875819fd7cf93({ profileData: profileData, cloudId: cloudId }) {
    const intl = (0, $aXWIB.useIntl)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { getDurationSinceInteraction: getDurationSinceInteraction } = (0, $8en9F.useCardOpenTimer)();
    const { townsquareApp: townsquareApp, onProfileClick: onProfileClick, getTestId: getTestId } = (0, $42omo.useContext)((0, $ikcEb.UserProfileCardContext));
    const { accountId: accountId, name: name, thirdPartyIntegrations: thirdPartyIntegrations, email: email } = profileData;
    const { href: href, target: target, onNavigate: onNavigate, isCrossAppMauGateEnabled: isCrossAppMauGateEnabled } = (0, $8SquK.useUserProfileLink)(accountId, cloudId, townsquareApp);
    const fireCrossAppProfileAnalytic = (0, $9jVmo.useFireCrossAppProfileAnalytic)(townsquareApp);
    const externalMessage = (0, $42omo.useMemo)(()=>(0, $3exdj.resolveExternalMessageFromIntegrations)(thirdPartyIntegrations, email), [
        email,
        thirdPartyIntegrations
    ]);
    const handleThirdPartyMessageClick = (0, $42omo.useCallback)(()=>{
        // Reuse the existing `@atlaskit/profilecard` clicked.action event so the SLO dashboards
        // see a single click-event surface for both profile-card packages. `index` and `hasOnClick`
        // are required by that schema but are not meaningful for user-profile-card actions, so we
        // always send `index: 0` and `hasOnClick: true`.
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(externalMessage?.dm.openDmUrl),
            hasOnClick: true,
            index: 0,
            actionId: 'thirdPartyMessage'
        });
    }, [
        fireEvent,
        getDurationSinceInteraction,
        externalMessage
    ]);
    const handleViewProfileClick = (0, $42omo.useCallback)((event)=>{
        fireEvent('ui.profilecard.clicked.action', {
            firedAt: (0, $6er8q.firedAt)(),
            duration: getDurationSinceInteraction() ?? 0,
            hasHref: Boolean(href),
            hasOnClick: true,
            index: 0,
            actionId: 'viewProfile'
        });
        if (isCrossAppMauGateEnabled) fireCrossAppProfileAnalytic();
        onProfileClick?.(accountId);
        onNavigate?.(event);
    }, [
        fireEvent,
        getDurationSinceInteraction,
        href,
        onNavigate,
        onProfileClick,
        isCrossAppMauGateEnabled,
        fireCrossAppProfileAnalytic,
        accountId
    ]);
    if (!accountId || !href) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, externalMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dE1p6.default), {
        href: externalMessage.dm.openDmUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: handleThirdPartyMessageClick,
        icon: (0, $dMSD4.getIconForExternalMessageIntegration)(externalMessage.dm.integration),
        label: intl.formatMessage($dd80962e40f8ea2d$var$messages.sendMessageLabel, {
            name: name
        })
    }), accountId && href && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        href: href,
        appearance: "default",
        target: target,
        onClick: handleViewProfileClick,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        testId: getTestId('view-profile-button')
    }, intl.formatMessage($dd80962e40f8ea2d$var$messages.viewProfile)));
}
module.exports["HeaderActions"] = $dd80962e40f8ea2d$export$223875819fd7cf93;

});

parcelRegister("9jVmo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4asqm = parcelRequire("4asqm");


var $inPa6 = parcelRequire("inPa6");

const $b85f75bd737ae266$export$c7eac394c4a88aeb = (townsquareApp)=>{
    // `fireCustomCrossAppAnalytic` needs raw `createAnalyticsEvent`, so this hook
    // intentionally owns the `@atlaskit/analytics-next` dependency.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useCallback)(()=>{
        if (!townsquareApp) return;
        (0, $4asqm.fireCustomCrossAppAnalytic)({
            tags: [
                'townsquare',
                'navigationExperiences'
            ],
            analyticsEventFireName: 'atlas',
            destinationApp: 'teams',
            bridge: `${townsquareApp}-customLink`,
            source: `townsquare-${townsquareApp}`,
            actionSubjectId: 'viewProfileLink',
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        townsquareApp,
        createAnalyticsEvent
    ]);
};
module.exports["useFireCrossAppProfileAnalytic"] = $b85f75bd737ae266$export$c7eac394c4a88aeb;

});

parcelRegister("8SquK", function(module, exports) {

var $ay6Zz = parcelRequire("ay6Zz");


var $1ACln = parcelRequire("1ACln");

const $2330b985c14490d3$export$a3989301a7f69ed7 = (userId, cloudId, townsquareApp)=>{
    const { href: rawHref, target: target, onNavigate: onNavigate } = (0, $ay6Zz.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId
    });
    // When no townsquareApp is provided, fall back to `'teams'` for the bridge string so
    // the analytics tag is always a real app name, never the literal `"undefined-customLink"`.
    const bridgeApp = townsquareApp ?? 'teams';
    const wrappedHref = (0, $1ACln.useGetCrossProductWrappedUrl)(`${bridgeApp}-customLink`, rawHref, townsquareApp);
    const href = townsquareApp ? wrappedHref : rawHref;
    const isCrossAppMauGateEnabled = Boolean(townsquareApp) && href !== rawHref;
    return {
        href: href,
        target: target,
        onNavigate: onNavigate,
        isCrossAppMauGateEnabled: isCrossAppMauGateEnabled
    };
};
module.exports["useUserProfileLink"] = $2330b985c14490d3$export$a3989301a7f69ed7;

});

parcelRegister("1ACln", function(module, exports) {

var $39XmP = parcelRequire("39XmP");


var $dh538 = parcelRequire("dh538");

const $6bf30137358d95af$export$2b163c291f77b3f9 = (bridge, url, app)=>{
    const sourceApp = app ?? 'teams';
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: bridge,
        product: 'townsquare',
        subProduct: sourceApp
    });
    return app !== undefined && app !== 'teams' && (0, $dh538.fg)('townsquare_teams_cross_app_mau') ? buildUrlWithAnalyticsParams(url) : url;
};
module.exports["useGetCrossProductWrappedUrl"] = $6bf30137358d95af$export$2b163c291f77b3f9;

});

parcelRegister("dMSD4", function(module, exports) {

var $alDWH = parcelRequire("alDWH");

const $dfc29d480e8ab830$export$ebea5317ff1808bf = {
    slack: (0, $alDWH.SlackIcon),
    teams: (0, $alDWH.TeamsIcon)
};
function $dfc29d480e8ab830$export$5a867b7c6687d757(integration) {
    return $dfc29d480e8ab830$export$ebea5317ff1808bf[integration];
}
module.exports["getIconForExternalMessageIntegration"] = $dfc29d480e8ab830$export$5a867b7c6687d757;

});

parcelRegister("alDWH", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $0caf0847675e2133$export$b33fb54b08bb6422() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
        fill: "#ECB22E"
    })));
}
function $0caf0847675e2133$export$1bcbc9c337da86da() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
        fill: "#7B83EB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.1",
        d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.2",
        d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
        fill: "#5059C9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
        fill: "white"
    }));
}
module.exports["SlackIcon"] = $0caf0847675e2133$export$b33fb54b08bb6422;
module.exports["TeamsIcon"] = $0caf0847675e2133$export$1bcbc9c337da86da;

});

parcelRegister("3exdj", function(module, exports) {

var $g9eXi = parcelRequire("g9eXi");

const $1541e528197b85f3$var$normalizeProductKey = (product)=>product.trim().toLowerCase();
/**
 * Keeps the first row for each `product` (case-insensitive). Order matches the input array.
 */ function $1541e528197b85f3$var$uniqueRowsByFirstOccurrence(integrations = []) {
    const seen = new Set();
    const out = [];
    for (const row of integrations){
        const key = $1541e528197b85f3$var$normalizeProductKey(row.product);
        if (seen.has(key)) continue;
        seen.add(key);
        out.push(row);
    }
    return out;
}
const $1541e528197b85f3$export$cf50127c50537c52 = [
    'slack',
    'teams'
];
function $1541e528197b85f3$export$523ecfa1815bea06(integrations, email, integrationIdOrder = $1541e528197b85f3$export$cf50127c50537c52) {
    const rows = $1541e528197b85f3$var$uniqueRowsByFirstOccurrence(integrations ? [
        ...integrations
    ] : []);
    for (const id of integrationIdOrder){
        const row = rows.find((r)=>r.integrationId === id);
        if (!row) continue;
        const entry = {
            email: email,
            externalId: row.externalId,
            integrationId: row.integrationId,
            product: row.product
        };
        const dm = (0, $g9eXi.getExternalMessageDmIntegrationInfo)(row.integrationId, {
            email: entry.email,
            externalId: entry.externalId
        });
        if (dm) return {
            entry: entry,
            dm: dm
        };
    }
    return undefined;
}
module.exports["resolveExternalMessageFromIntegrations"] = $1541e528197b85f3$export$523ecfa1815bea06;

});

parcelRegister("g9eXi", function(module, exports) {
const $06891aee358a4255$export$596e547f4ce626bc = (integrationId, user)=>{
    if (!integrationId || !user) return;
    const isSlack = integrationId === 'slack';
    const isMsTeams = integrationId === 'teams';
    if (isSlack) {
        const openDmUrl = $06891aee358a4255$export$9eb522d6e073fba0(user);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $06891aee358a4255$export$198aa8f5b10ebb27(user);
        if (openDmUrl) return {
            integration: 'teams',
            openDmUrl: openDmUrl
        };
    }
};
const $06891aee358a4255$export$9eb522d6e073fba0 = (user)=>{
    const externalId = user?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $06891aee358a4255$export$198aa8f5b10ebb27 = (user)=>{
    const email = user?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};
module.exports["getExternalMessageDmIntegrationInfo"] = $06891aee358a4255$export$596e547f4ce626bc;

});

parcelRegister("3rynt", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $esRft = parcelRequire("esRft");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");

const $c052bc18bed19d18$var$messages = (0, $aXWIB.defineMessages)({
    managerHeading: {
        id: "user-profile-card.manager.heading",
        defaultMessage: "Manager"
    }
});
function $c052bc18bed19d18$export$2992b481dad9fb03({ manager: manager, testId: testId }) {
    const intl = (0, $aXWIB.useIntl)();
    const { name: name, avatarUrl: avatarUrl, jobTitle: jobTitle } = manager;
    if (!name) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p",
        weight: "medium",
        color: "color.text"
    }, intl.formatMessage($c052bc18bed19d18$var$messages.managerHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarUrl ?? undefined,
        name: name,
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 1
    }, name), jobTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, jobTitle))));
}
module.exports["ManagerSection"] = $c052bc18bed19d18$export$2992b481dad9fb03;

});

parcelRegister("5QyNZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $cBiyA = parcelRequire("cBiyA");

const $a453294bcbadcae5$var$messages = (0, $aXWIB.defineMessages)({
    recentWorkHeading: {
        id: "user-profile-card.recent-work.heading",
        defaultMessage: "Recent work"
    }
});
function $a453294bcbadcae5$export$5981f4ad4928b105({ recentWorkData: recentWorkData, testId: testId }) {
    const intl = (0, $aXWIB.useIntl)();
    if (recentWorkData.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p",
        weight: "medium",
        color: "color.text"
    }, intl.formatMessage($a453294bcbadcae5$var$messages.recentWorkHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cBiyA.LinkList), {
        urls: recentWorkData
    })));
}
module.exports["RecentWorkSection"] = $a453294bcbadcae5$export$5981f4ad4928b105;

});

parcelRegister("cBiyA", function(module, exports) {
/* link-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7bZ3i = parcelRequire("7bZ3i");


var $ftdyH = parcelRequire("ftdyH");


var $6AswO = parcelRequire("6AswO");

const $de24bf906e414d3f$var$containerRoot = null;
const $de24bf906e414d3f$var$showCompact = null;
const $de24bf906e414d3f$var$showFull = null;
const $de24bf906e414d3f$export$533f831a441a4b64 = 4;
const $de24bf906e414d3f$export$bec64ed398b2de33 = ({ urls: urls, onLinkClick: onLinkClick })=>{
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1bsb1osq _7cca15wb _1f381bi7"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $7bZ3i.SmartCardProvider), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1ule _1h0uglyw"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $ftdyH.LinkListCompact), {
        urls: urls,
        onLinkClick: onLinkClick
    })), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0cglyw _1h0u1ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $6AswO.LinkListFull), {
        urls: urls,
        onLinkClick: onLinkClick
    }))));
};
module.exports["LinkList"] = $de24bf906e414d3f$export$bec64ed398b2de33;

});

parcelRegister("ftdyH", function(module, exports) {
/* link-list-compact.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $kpYGL = parcelRequire("kpYGL");


var $hpUsb = parcelRequire("hpUsb");

var $5TXU5 = parcelRequire("5TXU5");

var $1lLfV = parcelRequire("1lLfV");

var $5znEc = parcelRequire("5znEc");


var $5dtQ2 = parcelRequire("5dtQ2");


var $hYkAl = parcelRequire("hYkAl");


var $8F3Ib = parcelRequire("8F3Ib");

const $be34308c5e894274$var$styles = {
    root: "_5wra1l7x _t6vde4h9 _1p3lnqa1 _mowc1l7x _hr4je4h9 _1apgnqa1 _kqswh2mm _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _irr31dpa",
    linkWrapperUnresolved: "_1tke8vuz",
    unresolvedSkeletonOverlay: "_1r04idpf _2rko1qi0 _kqswstnw _bfhkhfxm _1pbykb7n",
    borderTop: "_1i531l7x _uwhke4h9 _15a5nqa1",
    borderTopRounded: "_13li1qi0 _qrwq1qi0",
    borderBottomRounded: "_1o3i1l7x _1doce4h9 _1il9nqa1 _mrkb1qi0 _1o0z1qi0",
    loadingContainer: "_ca0qutpp _19bvutpp",
    loadingSkeletonRows: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    expandWrapper: "_1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qu2gc _u5f3u2gc _n3tdu2gc _4t3i1ylp"
};
const $be34308c5e894274$var$unboundedStyles = {
    unboundedTitleWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul91w81",
    unboundedTitleBlock: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf _1rguze3t _1sy51mok _8e0ku2gc _1a40u2gc _12yxu2gc _1qamu2gc _1em3i8nm _18tpr5cr",
    unboundedMetadataWrapper: "_1de7glyw",
    metadataStateSlot: "_1o9zidpf _1e0c1txw _1bahesu3 _18u0utpp",
    metadataPrioritySlot: "_1o9zidpf _18u0u2gc"
};
const $be34308c5e894274$var$messages = (0, $aXWIB.defineMessages)({
    link_list_expand: {
        id: "smart_knowledge_card.link_list_compact_expand",
        defaultMessage: "Show more"
    },
    link_list_collapse: {
        id: "smart_knowledge_card.link_list_compact_collapse",
        defaultMessage: "Show less"
    }
});
const $be34308c5e894274$var$LinkListCompactComponent = ({ url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick })=>{
    const [resolved, setResolved] = (0, $42omo.useState)(false);
    const handleResolve = ()=>setResolved(true);
    const handleError = ()=>{
        handleResolve();
        onError();
    };
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $hYkAl.createLinkClickHandlers)(onLinkClick, url, idx);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.root, $be34308c5e894274$var$styles.borderTop, borderTopRounded && $be34308c5e894274$var$styles.borderTopRounded, borderBottomRounded && $be34308c5e894274$var$styles.borderBottomRounded, !resolved && $be34308c5e894274$var$styles.linkWrapperUnresolved),
        testId: `link-list-compact-item-${idx}${borderTopRounded ? '-top-rounded' : ''}${borderBottomRounded ? '-bottom-rounded' : ''}`,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        appearance: "block",
        url: url,
        onClick: onClick,
        ui: {
            theme: (0, $5TXU5.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $5TXU5.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        onError: handleError,
        onResolve: handleResolve
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        xcss: $be34308c5e894274$var$unboundedStyles.unboundedTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $be34308c5e894274$var$unboundedStyles.unboundedTitleBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        maxLines: 1,
        showActionOnHover: true,
        subtitle: [
            {
                name: (0, $5TXU5.ElementName).Provider,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ElementName).ModifiedOn
            }
        ],
        position: (0, $5TXU5.SmartLinkPosition).Center
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $be34308c5e894274$var$unboundedStyles.metadataStateSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).State
            }
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        xcss: $be34308c5e894274$var$unboundedStyles.unboundedMetadataWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $be34308c5e894274$var$unboundedStyles.metadataPrioritySlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).Priority
            }
        ]
    }))))), !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.unresolvedSkeletonOverlay, $be34308c5e894274$var$styles.loadingContainer),
        testId: "unresolved-loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "16px",
        height: "16px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $be34308c5e894274$var$styles.loadingSkeletonRows,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "40%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "70%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })))));
};
const $be34308c5e894274$export$1fbb558f111cbbf9 = ({ urls: urls, onLinkClick: onLinkClick })=>{
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $8F3Ib.useLinkListMarkErrored)(); // All non-errored original indices, preserving original positions
    const visibleIndices = urls.map((_, i)=>i).filter((i)=>!erroredIndices.has(i)); // Whether to show the expand/collapse button at all
    const hasMore = visibleIndices.length > (0, $5dtQ2.DEFAULT_MAX_SOURCES); // The indices we actually render — slice to DEFAULT_MAX_SOURCES when collapsed
    const renderedIndices = isExpanded ? visibleIndices : visibleIndices.slice(0, (0, $5dtQ2.DEFAULT_MAX_SOURCES));
    const firstVisibleIdx = renderedIndices[0] ?? -1;
    const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.0"
    }, renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($be34308c5e894274$var$LinkListCompactComponent, {
            key: `${urls[originalIdx]}-${originalIdx}`,
            url: urls[originalIdx],
            idx: originalIdx,
            borderTopRounded: originalIdx === firstVisibleIdx,
            borderBottomRounded: originalIdx === lastVisibleIdx && !hasMore,
            onError: ()=>markErrored(originalIdx),
            onLinkClick: onLinkClick
        })), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($be34308c5e894274$var$styles.expandWrapper, $be34308c5e894274$var$styles.borderBottomRounded),
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: ()=>setIsExpanded(!isExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $be34308c5e894274$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $be34308c5e894274$var$messages.link_list_expand)))));
};
module.exports["LinkListCompact"] = $be34308c5e894274$export$1fbb558f111cbbf9;

});

parcelRegister("5dtQ2", function(module, exports) {
const $6b624b5882fc4b79$export$533f831a441a4b64 = 4;
module.exports["DEFAULT_MAX_SOURCES"] = $6b624b5882fc4b79$export$533f831a441a4b64;

});

parcelRegister("hYkAl", function(module, exports) {
const $9c9c61899a9d09f4$export$bfdc42a78eb8bcc6 = (onLinkClick, url, idx)=>{
    if (!onLinkClick) return {
        onClick: undefined,
        onAuxClick: undefined,
        onContextMenu: undefined
    };
    return {
        onClick: ()=>onLinkClick(url, idx),
        onAuxClick: (e)=>{
            if (e.button === 1) onLinkClick(url, idx, {
                isAuxClick: true
            });
        },
        onContextMenu: (_e)=>onLinkClick(url, idx, {
                isContextMenu: true
            })
    };
};
module.exports["createLinkClickHandlers"] = $9c9c61899a9d09f4$export$bfdc42a78eb8bcc6;

});

parcelRegister("8F3Ib", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $af964aae8a362311$export$9441241ba5515b77 = ()=>{
    const [erroredIndices, setErroredIndices] = (0, $42omo.useState)(new Set());
    const markErrored = (idx)=>setErroredIndices((prev)=>new Set(prev).add(idx));
    return {
        erroredIndices: erroredIndices,
        markErrored: markErrored
    };
};
module.exports["useLinkListMarkErrored"] = $af964aae8a362311$export$9441241ba5515b77;

});

parcelRegister("6AswO", function(module, exports) {
/* link-list-full.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2Pg7f = parcelRequire("2Pg7f");


var $ccHMk = parcelRequire("ccHMk");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $kpYGL = parcelRequire("kpYGL");


var $5TXU5 = parcelRequire("5TXU5");

var $hpUsb = parcelRequire("hpUsb");

var $1lLfV = parcelRequire("1lLfV");

var $5znEc = parcelRequire("5znEc");


var $5dtQ2 = parcelRequire("5dtQ2");


var $hYkAl = parcelRequire("hYkAl");


var $8F3Ib = parcelRequire("8F3Ib");

const $c55bd8c5797796c1$var$styles = {
    root: "_5wra1l7x _t6vde4h9 _1p3lnqa1 _mowc1l7x _hr4je4h9 _1apgnqa1 _kqswh2mm _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _irr31dpa",
    linkWrapperUnresolved: "_1tke1ex1",
    unresolvedSkeletonOverlay: "_1r04idpf _2rko1qi0 _kqswstnw _bfhkhfxm _1pbykb7n",
    borderTop: "_1i531l7x _uwhke4h9 _15a5nqa1",
    borderTopRounded: "_13li1qi0 _qrwq1qi0",
    borderBottomRounded: "_1o3i1l7x _1doce4h9 _1il9nqa1 _mrkb1qi0 _1o0z1qi0",
    loadingContainer: "_ca0qutpp _19bvutpp",
    loadingSkeletonRows: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
    expandWrapper: "_1h6d1l7x _189ee4h9 _1dqonqa1 _ca0qu2gc _u5f3u2gc _n3tdu2gc _4t3i1ylp"
};
const $c55bd8c5797796c1$var$unboundedStyles = {
    unboundedTitleWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul91w81",
    unboundedTitleBlock: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf _1rguze3t _1sy51mok _8e0ku2gc _1a40u2gc _12yxu2gc _1qamu2gc _1em3i8nm _18tpr5cr _1bac1mp2 _13bou2gc",
    hideTitleStyles: "_u4a7glyw _502wglyw",
    unboundedMetadataWrapper: "_1de7glyw",
    metadataModifiedOnSlot: "_1bsb1w81 _1o9zidpf _18u0utpp",
    metadataStateSlot: "_1o9zidpf _1e0c1txw _1bahesu3 _18u0utpp",
    metadataPrioritySlot: "_1bsbzwfg _1o9zidpf _18u0u2gc",
    metadataAuthorSlot: "_1bsb1wqb _1o9zidpf _18u0pxbi",
    previewSlot: "_1bsb1tcg _1o9zidpf"
};
const $c55bd8c5797796c1$var$messages = (0, $aXWIB.defineMessages)({
    link_list_expand: {
        id: "smart_knowledge_card.link_list_full_expand",
        defaultMessage: "Show more"
    },
    link_list_collapse: {
        id: "smart_knowledge_card.link_list_full_collapse",
        defaultMessage: "Show less"
    }
});
const $c55bd8c5797796c1$var$avatarOverrideLinks = [
    'https://github.com/org-beaconstone/titan/pull/12'
];
const $c55bd8c5797796c1$var$LinkListFullComponent = ({ url: url, idx: idx, borderTopRounded: borderTopRounded, borderBottomRounded: borderBottomRounded, onError: onError, onLinkClick: onLinkClick })=>{
    const [resolved, setResolved] = (0, $42omo.useState)(false);
    const handleResolve = ()=>setResolved(true);
    const handleError = ()=>{
        handleResolve();
        onError();
    };
    const { onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu } = (0, $hYkAl.createLinkClickHandlers)(onLinkClick, url, idx);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.root, $c55bd8c5797796c1$var$styles.borderTop, borderTopRounded && $c55bd8c5797796c1$var$styles.borderTopRounded, borderBottomRounded && $c55bd8c5797796c1$var$styles.borderBottomRounded, !resolved && $c55bd8c5797796c1$var$styles.linkWrapperUnresolved),
        testId: `link-list-full-item-${idx}${borderTopRounded ? '-top-rounded' : ''}${borderBottomRounded ? '-bottom-rounded' : ''}`,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        appearance: "block",
        url: url,
        onClick: onClick,
        ui: {
            theme: (0, $5TXU5.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $5TXU5.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        onError: handleError,
        onResolve: handleResolve
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        xcss: $c55bd8c5797796c1$var$unboundedStyles.unboundedTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.unboundedTitleBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        maxLines: 1,
        showActionOnHover: true,
        subtitle: [
            {
                name: (0, $5TXU5.ElementName).Provider,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ElementName).CreatedBy
            }
        ],
        position: (0, $5TXU5.SmartLinkPosition).Center
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataStateSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).State
            }
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        xcss: $c55bd8c5797796c1$var$unboundedStyles.unboundedMetadataWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataAuthorSlot
    }, $c55bd8c5797796c1$var$avatarOverrideLinks.includes(url) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        appearance: "stack",
        size: "small",
        maxCount: 1,
        data: [
            {
                name: 'beaconstone',
                src: 'https://avatars.githubusercontent.com/u/276804974?v=4'
            }
        ]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).AuthorGroup
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataModifiedOnSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).ModifiedOn
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c55bd8c5797796c1$var$unboundedStyles.metadataPrioritySlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lLfV.default), {
        maxLines: 1,
        primary: [
            {
                name: (0, $5TXU5.ElementName).Priority
            }
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$unboundedStyles.hideTitleStyles, $c55bd8c5797796c1$var$unboundedStyles.previewSlot)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        maxLines: 1,
        actions: [
            {
                name: (0, $5TXU5.ActionName).PreviewAction,
                hideContent: true
            }
        ],
        showActionOnHover: true,
        position: (0, $5TXU5.SmartLinkPosition).Center
    }))))), !resolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.unresolvedSkeletonOverlay, $c55bd8c5797796c1$var$styles.loadingContainer),
        testId: "unresolved-loading-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "16px",
        height: "16px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $c55bd8c5797796c1$var$styles.loadingSkeletonRows,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "40%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "70%",
        height: "12px",
        borderRadius: "var(--ds-radius-small, 4px)"
    })))));
};
const $c55bd8c5797796c1$export$984f8adc5ac31b30 = ({ urls: urls, onLinkClick: onLinkClick })=>{
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const { erroredIndices: erroredIndices, markErrored: markErrored } = (0, $8F3Ib.useLinkListMarkErrored)(); // All non-errored original indices, preserving original positions
    const visibleIndices = urls.map((_, i)=>i).filter((i)=>!erroredIndices.has(i)); // Whether to show the expand/collapse button at all
    const hasMore = visibleIndices.length > (0, $5dtQ2.DEFAULT_MAX_SOURCES); // The indices we actually render — slice to DEFAULT_MAX_SOURCES when collapsed
    const renderedIndices = isExpanded ? visibleIndices : visibleIndices.slice(0, (0, $5dtQ2.DEFAULT_MAX_SOURCES));
    const firstVisibleIdx = renderedIndices[0] ?? -1;
    const lastVisibleIdx = renderedIndices[renderedIndices.length - 1] ?? -1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.0"
    }, renderedIndices.map((originalIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c55bd8c5797796c1$var$LinkListFullComponent, {
            key: `${urls[originalIdx]}-${originalIdx}`,
            url: urls[originalIdx],
            idx: originalIdx,
            borderTopRounded: originalIdx === firstVisibleIdx,
            borderBottomRounded: originalIdx === lastVisibleIdx && !hasMore,
            onError: ()=>markErrored(originalIdx),
            onLinkClick: onLinkClick
        })), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: (0, $1Whri.cx)($c55bd8c5797796c1$var$styles.expandWrapper, $c55bd8c5797796c1$var$styles.borderBottomRounded),
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: ()=>setIsExpanded(!isExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c55bd8c5797796c1$var$messages.link_list_collapse) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $c55bd8c5797796c1$var$messages.link_list_expand)))));
};
module.exports["LinkListFull"] = $c55bd8c5797796c1$export$984f8adc5ac31b30;

});

parcelRegister("3Gey6", function(module, exports) {
/**
 * @generated SignedSource<<17f6713d861412383f837d08875b5f76>>
 * @relayHash ce0cc0869eaa104ffbaad1840374155d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 37f28cf189387324ca478480bce30f6ad78557d043534b42b61667152ccc504a
const $88c913f65753a156$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userIdString"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewerId"
    }, v6 = {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v10 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v13 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v12 /*: any*/ 
        }
    ], v14 = [
        {
            "kind": "ScalarField",
            "name": "webUrl"
        }
    ], v15 = [
        v11 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "userAri",
                            "variableName": "userAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        },
                        {
                            "kind": "Variable",
                            "name": "userIdString",
                            "variableName": "userIdString"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewerId",
                            "variableName": "viewerId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "UserProfileCardRelay_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserProfileCardEntryPointQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "accountId",
                            "variableName": "userId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "department"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "location"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "organization"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "items": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "actors.0",
                                                    "variableName": "userAri"
                                                }
                                            ],
                                            "kind": "ListValue",
                                            "name": "actors"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filter"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 10
                                }
                            ],
                            "concreteType": "ActivityConnection",
                            "kind": "LinkedField",
                            "name": "workedOn",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ActivityItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityObject",
                                                    "kind": "LinkedField",
                                                    "name": "object",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluencePageLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v12 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceBlogPostLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v12 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceBlogPost"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceWhiteboardLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v12 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceWhiteboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v13 /*: any*/ ,
                                                                    "type": "ConfluenceInlineComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v13 /*: any*/ ,
                                                                    "type": "ConfluenceFooterComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v14 /*: any*/ ,
                                                                    "type": "JiraIssue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v14 /*: any*/ ,
                                                                    "type": "JiraPlatformComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v14 /*: any*/ ,
                                                                    "type": "JiraServiceManagementComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "href"
                                                                        }
                                                                    ],
                                                                    "type": "BitbucketPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": "loomUrl",
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "LoomVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v15 /*: any*/ ,
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v15 /*: any*/ ,
                                                                    "type": "DevOpsPullRequestDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v15 /*: any*/ ,
                                                                    "type": "MercuryPortfolio"
                                                                }
                                                            ]
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "KnowledgeDiscoveryQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeDiscovery",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "accountId",
                                    "variableName": "userIdString"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "requestingUserId",
                                    "variableName": "viewerId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "tenantId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "singleUser",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeDiscoveryUserProfile",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeDiscoveryUserManager",
                                                    "kind": "LinkedField",
                                                    "name": "manager",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                    "kind": "LinkedField",
                                                    "name": "thirdPartyIntegrations",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "externalId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "integrationId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "product"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "KnowledgeDiscoverySingleUser"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "37f28cf189387324ca478480bce30f6ad78557d043534b42b61667152ccc504a",
            "metadata": {},
            "name": "UserProfileCardEntryPointQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$88c913f65753a156$var$node.hash = "85cac0d771f87f5698cf3c18dcde5c03";
var $88c913f65753a156$export$2e2bcd8739ae039 = $88c913f65753a156$var$node;
module.exports["default"] = $88c913f65753a156$export$2e2bcd8739ae039;

});

parcelRegister("4G9a0", function(module, exports) {

let $368230b741037419$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $368230b741037419$var$load("i8mSI").then(()=>parcelRequire('ahqGM'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("2TEGg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dh538 = parcelRequire("dh538");


var $O1c6O = parcelRequire("O1c6O");

var $fDXXi = parcelRequire("fDXXi");


var $j5l6c = parcelRequire("j5l6c");


var $g5lKx = parcelRequire("g5lKx");


var $gWF6I = parcelRequire("gWF6I");


var $6er8q = parcelRequire("6er8q");


var $e8zaz = parcelRequire("e8zaz");


var $oZBat = parcelRequire("oZBat");


var $4pG2n = parcelRequire("4pG2n");


var $8en9F = parcelRequire("8en9F");


var $ikcEb = parcelRequire("ikcEb");


var $cptht = parcelRequire("cptht");


var $4dNEc = parcelRequire("4dNEc");


var $2205s = parcelRequire("2205s");


var $lOr8f = parcelRequire("lOr8f");

function $082089d6a39bcf3b$export$74fa5d03ff375804(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($082089d6a39bcf3b$var$UserProfileCardWithTriggerInner, props));
}
/** Inner implementation of {@link UserProfileCardWithTrigger}. */ function $082089d6a39bcf3b$var$UserProfileCardWithTriggerInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, trigger: trigger, placement: placement = 'bottom-start', shouldRenderToParent: shouldRenderToParent = false, children: children, testId: testId, townsquareApp: townsquareApp, onProfileClick: onProfileClick }) {
    const PopupTriggerWithHover = (0, $dh538.fg)('people-teams_migrate-popup-adaptor-package') ? (0, $j5l6c.PopupTriggerWithHover) : (0, $4pG2n.PopupTriggerWithHover);
    const resolvedTriggerMode = trigger ?? 'click';
    const entryPointErrorFallback = (0, $42omo.useCallback)((_props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4dNEc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const getTestId = (0, $42omo.useMemo)(()=>(0, $cptht.makeGetTestId)(userId, testId), [
        userId,
        testId
    ]);
    // `triggerMethod` is the actual open method ('click' | 'hover') reported by the popup
    // adapter. It stays `undefined` until the first open so we never report a trigger-mode
    // value (e.g. 'preload-on-hover') as if it were an open method. This is hoisted onto
    // `TeamsAppAnalyticsContext.attributes` below so every analytics event fired beneath
    // the popup picks it up automatically without each event having to attach it manually.
    const [triggerMethod, setTriggerMethod] = (0, $42omo.useState)(undefined);
    const contextValue = (0, $42omo.useMemo)(()=>({
            cloudId: cloudId,
            townsquareApp: townsquareApp,
            onProfileClick: onProfileClick,
            getTestId: getTestId
        }), [
        cloudId,
        townsquareApp,
        onProfileClick,
        getTestId
    ]);
    const analyticsContextData = (0, $42omo.useMemo)(()=>({
            source: 'userProfileCard',
            attributes: {
                cloudId: cloudId,
                userId: userId,
                viewerId: viewerId,
                // Only attach `method` once an actual open has occurred so SLO dashboards never
                // see a synthetic method on pre-open events (e.g. preload).
                ...triggerMethod !== undefined ? {
                    method: triggerMethod
                } : {}
            }
        }), [
        cloudId,
        viewerId,
        userId,
        triggerMethod
    ]);
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ikcEb.UserProfileCardContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $O1c6O.TeamsAppAnalyticsContext), {
        data: analyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8en9F.CardOpenTimerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($082089d6a39bcf3b$var$UserProfileCardPopupWithAnalytics, {
        PopupTriggerWithHover: PopupTriggerWithHover,
        entryPointParams: {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        },
        entryPointProps: {
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId,
            testId: testId
        },
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        triggerMode: resolvedTriggerMode,
        errorFallback: entryPointErrorFallback,
        onTriggerMethodChange: setTriggerMethod,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lOr8f.UserProfileCardTrigger), {
                trigger: resolvedTriggerMode,
                triggerProps: triggerProps
            }, children)
    })))));
}
function $082089d6a39bcf3b$var$UserProfileCardPopupWithAnalytics({ PopupTriggerWithHover: PopupTriggerWithHover, entryPointParams: entryPointParams, entryPointProps: entryPointProps, placement: placement, shouldRenderToParent: shouldRenderToParent, triggerMode: triggerMode, errorFallback: errorFallback, onTriggerMethodChange: onTriggerMethodChange, trigger: trigger }) {
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { markInteractionStart: markInteractionStart } = (0, $8en9F.useCardOpenTimer)();
    const fireTriggeredRequest = (0, $e8zaz.useFireTriggeredRequest)();
    const handleOpen = (0, $42omo.useCallback)((method)=>{
        // t=0 for all downstream `duration` measurements.
        markInteractionStart();
        onTriggerMethodChange(method);
        // `method` is attached inline because the context update from
        // `onTriggerMethodChange` has not propagated yet at this exact moment.
        fireEvent('ui.profilecard.triggered', {
            firedAt: (0, $6er8q.firedAt)(),
            method: method
        });
        fireTriggeredRequest();
    }, [
        fireEvent,
        fireTriggeredRequest,
        markInteractionStart,
        onTriggerMethodChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopupTriggerWithHover, {
        entryPoint: (0, $oZBat.entryPoint),
        placement: placement,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2205s.CardLoading), {
            testId: entryPointProps.testId ?? ''
        }),
        errorFallback: errorFallback,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        shouldRenderToParent: shouldRenderToParent,
        shouldUseCaptureOnOutsideClick: true,
        zIndex: (0, $g5lKx.layers).modal(),
        triggerMode: triggerMode,
        onOpen: handleOpen,
        trigger: trigger
    });
}
module.exports["UserProfileCardWithTrigger"] = $082089d6a39bcf3b$export$74fa5d03ff375804;

});

parcelRegister("4pG2n", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $4rwCt = parcelRequire("4rwCt");


var $lGgRw = parcelRequire("lGgRw");


var $9hlns = parcelRequire("9hlns");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");


var $bjTis = parcelRequire("bjTis");


var $aziFL = parcelRequire("aziFL");


var $l5XO6 = parcelRequire("l5XO6");

const $08773b11ef01d4f2$var$emptyEntryPointParams = {};
const $08773b11ef01d4f2$var$emptyEntryPointProps = {};
const $08773b11ef01d4f2$var$FallbackComponent = ({ fallback: fallback, onUnmount: onUnmount })=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>onUnmount();
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), null));
};
function $08773b11ef01d4f2$export$afca832e0d04586a({ trigger: trigger, triggerMode: triggerMode, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onOpen: onOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const id = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [content, setContent] = (0, $42omo.useState)(null);
    const updateRef = (0, $42omo.useRef)(null);
    const openedByRef = (0, $42omo.useRef)(null);
    const triggers = Array.isArray(triggerMode) ? triggerMode : [
        triggerMode
    ];
    const handleOpen = (0, $42omo.useCallback)((method)=>{
        setIsOpen(true);
        if (method) onOpen?.(method);
    }, [
        onOpen
    ]);
    const handleClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event ?? null, currentLevel);
    }, [
        onClose
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $08773b11ef01d4f2$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference })=>{
        if (isOpen) return;
        handleOpen(openedByRef.current);
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $48FEk.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($08773b11ef01d4f2$var$FallbackComponent, {
                fallback: fallback,
                onUnmount: ()=>updateRef.current?.()
            }),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $08773b11ef01d4f2$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose
            },
            onError: onError,
            forcedError: forcedReportErrorUFO
        }));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const preloadRef = (0, $aziFL.usePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const pressableRef = (0, $l5XO6.usePressableTriggerRef)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('click'),
        openedByRef: openedByRef
    });
    const { triggerRef: hoverTriggerRef, contentRef: hoverContentRef } = (0, $bjTis.useHoverTriggerRef)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('hover'),
        openedByRef: openedByRef
    });
    (0, $42omo.useEffect)(()=>{
        if (!isOpen) openedByRef.current = null;
    }, [
        isOpen
    ]);
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4rwCt.mergeRefs)([
            preloadRef,
            pressableRef,
            hoverTriggerRef,
            triggerProps.ref
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        preloadRef,
        pressableRef,
        hoverTriggerRef
    ]);
    const popupContent = (0, $42omo.useCallback)(({ update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: hoverContentRef,
            role: "none"
        }, content);
    }, [
        content,
        hoverContentRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}
module.exports["PopupTriggerWithHover"] = $08773b11ef01d4f2$export$afca832e0d04586a;

});

parcelRegister("bjTis", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ixI8a = parcelRequire("ixI8a");


var $5b9Wi = parcelRequire("5b9Wi");

const $036bc09e0dcbcac4$var$HOVER_OPEN_DELAY = 800;
const $036bc09e0dcbcac4$var$HOVER_CLOSE_DELAY = 200;
function $036bc09e0dcbcac4$export$b8df9ab832b125ac({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef, delays: delays = {} }) {
    const { hoverOpen: hoverOpen = $036bc09e0dcbcac4$var$HOVER_OPEN_DELAY, hoverClose: hoverClose = $036bc09e0dcbcac4$var$HOVER_CLOSE_DELAY } = delays;
    const triggerNodeRef = (0, $42omo.useRef)(null);
    const triggerListeners = (0, $42omo.useRef)([]);
    const contentNodeRef = (0, $42omo.useRef)(null);
    const contentListeners = (0, $42omo.useRef)(new Map());
    const isOpenRef = (0, $42omo.useRef)(isOpen);
    (0, $42omo.useLayoutEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    const openDelay = (0, $ixI8a.useHoverDelay)(()=>{
        if (isOpenRef.current) return;
        if (openedByRef) openedByRef.current = 'hover';
        onOpen();
    }, hoverOpen);
    const closeDelay = (0, $ixI8a.useHoverDelay)(()=>{
        if (!isOpenRef.current) return;
        if (!openedByRef || openedByRef.current === 'hover') onClose?.();
    }, hoverClose);
    const openDelayRef = (0, $42omo.useRef)(openDelay);
    const closeDelayRef = (0, $42omo.useRef)(closeDelay);
    openDelayRef.current = openDelay;
    closeDelayRef.current = closeDelay;
    const handleTriggerEnter = (0, $42omo.useCallback)(()=>{
        closeDelayRef.current.clear();
        openDelayRef.current.schedule();
    }, []);
    const handleTriggerLeave = (0, $42omo.useCallback)(()=>{
        openDelayRef.current.clear();
        closeDelayRef.current.schedule();
    }, []);
    const triggerRef = (0, $42omo.useCallback)((element)=>{
        if (element === triggerNodeRef.current) return;
        triggerListeners.current.forEach((unbind)=>unbind());
        triggerListeners.current = [];
        triggerNodeRef.current = element;
        if (element && !isDisabled) triggerListeners.current.push((0, $fFa3V.bind)(element, {
            type: 'mouseenter',
            listener: handleTriggerEnter
        }), (0, $fFa3V.bind)(element, {
            type: 'mouseleave',
            listener: handleTriggerLeave
        }));
    }, [
        handleTriggerEnter,
        handleTriggerLeave,
        isDisabled
    ]);
    const handleContentEnter = (0, $42omo.useCallback)(()=>{
        closeDelayRef.current.clear();
    }, []);
    const cleanupContentListeners = (0, $42omo.useCallback)(()=>{
        contentListeners.current.forEach((unbind)=>unbind());
        contentListeners.current.clear();
    }, []);
    const attachContentListeners = (0, $42omo.useCallback)((element)=>{
        if (contentListeners.current.has(element)) return;
        const handleMouseLeave = (event)=>{
            if (!(0, $5b9Wi.hasRelatedTarget)(event)) return;
            const relatedTarget = event.relatedTarget;
            if ((0, $5b9Wi.isMovingToKudos)(relatedTarget)) return;
            const childPortal = (0, $5b9Wi.getChildPortalFromParentPopup)(relatedTarget, contentNodeRef.current);
            if (childPortal) {
                attachContentListeners(childPortal);
                return;
            }
            closeDelayRef.current.schedule();
        };
        const unbindEnter = (0, $fFa3V.bind)(element, {
            type: 'mouseenter',
            listener: handleContentEnter
        });
        const unbindLeave = (0, $fFa3V.bind)(element, {
            type: 'mouseleave',
            listener: handleMouseLeave
        });
        contentListeners.current.set(element, ()=>{
            unbindEnter();
            unbindLeave();
        });
    }, [
        handleContentEnter
    ]);
    const contentRef = (0, $42omo.useCallback)((element)=>{
        if (element === contentNodeRef.current) return;
        cleanupContentListeners();
        contentNodeRef.current = element;
        if (element && !isDisabled) attachContentListeners(element);
    }, [
        attachContentListeners,
        cleanupContentListeners,
        isDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        const listeners = contentListeners.current;
        const triggers = triggerListeners.current;
        return ()=>{
            openDelayRef.current.clear();
            closeDelayRef.current.clear();
            triggers.forEach((unbind)=>unbind());
            listeners.forEach((unbind)=>unbind());
        };
    }, []);
    return {
        triggerRef: triggerRef,
        contentRef: contentRef
    };
}
module.exports["useHoverTriggerRef"] = $036bc09e0dcbcac4$export$b8df9ab832b125ac;

});

parcelRegister("ixI8a", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * Hook for managing delayed hover actions with timeout management.
 */ function $c8f11ac7b8cef868$export$beb151954e0eb9fa(callback, delay) {
    const timeoutRef = (0, $42omo.useRef)(null);
    const callbackRef = (0, $42omo.useRef)(callback);
    (0, $42omo.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const clear = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const schedule = (0, $42omo.useCallback)(()=>{
        clear();
        timeoutRef.current = window.setTimeout(()=>{
            callbackRef.current();
        }, delay);
    }, [
        delay,
        clear
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>clear();
    }, [
        clear
    ]);
    return {
        schedule: schedule,
        clear: clear
    };
}
module.exports["useHoverDelay"] = $c8f11ac7b8cef868$export$beb151954e0eb9fa;

});

parcelRegister("5b9Wi", function(module, exports) {
/**
 * Type guard to check if an event has a relatedTarget property.
 */ function $cd8e023101467c6c$export$63ce2e5e32c4f6a0(event) {
    return 'relatedTarget' in event;
}
/**
 * Checks if the mouse is moving to an atlaskit portal or kudos modal
 * where we should prevent the popup from closing
 */ function $cd8e023101467c6c$export$386001e6036bddcf(relatedTarget) {
    if (!(relatedTarget instanceof HTMLElement)) return false;
    const iframe = relatedTarget.closest('.atlaskit-portal')?.querySelector('iframe') || relatedTarget.closest('iframe');
    return iframe instanceof HTMLIFrameElement && iframe.src.includes('give-kudos');
}
/**
 * Returns the child portal if mouse is moving to a portal controlled by the parent popup.
 */ function $cd8e023101467c6c$export$a5fb0bbf4bb0e26a(relatedTarget, parentPopupElement) {
    if (!(relatedTarget instanceof HTMLElement) || !parentPopupElement) return null;
    const portal = relatedTarget.closest('.atlaskit-portal');
    if (!portal) return null;
    for (const trigger of parentPopupElement.querySelectorAll('[aria-controls]')){
        const controlsId = trigger.getAttribute('aria-controls');
        if (controlsId && portal.querySelector(`#${controlsId}`)) return portal;
    }
    return null;
}
module.exports["hasRelatedTarget"] = $cd8e023101467c6c$export$63ce2e5e32c4f6a0;
module.exports["isMovingToKudos"] = $cd8e023101467c6c$export$386001e6036bddcf;
module.exports["getChildPortalFromParentPopup"] = $cd8e023101467c6c$export$a5fb0bbf4bb0e26a;

});

parcelRegister("aziFL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

const $c268b218f7087397$var$PRELOAD_MAX_AGE = 300000;
const $c268b218f7087397$var$TIME_TO_INTENT = 200;
function $c268b218f7087397$export$e0cecaf2b8cc8d36({ load: load, onLoad: onLoad }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const { loadAndOpen: loadAndOpen, preloadReference: preloadReference, cancelPreload: cancelPreload } = (0, $42omo.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const loadAndOpen = ()=>{
            clearPreloadTimeouts();
            onLoad(loadReference());
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $c268b218f7087397$var$PRELOAD_MAX_AGE);
            }, $c268b218f7087397$var$TIME_TO_INTENT);
        };
        return {
            loadAndOpen: loadAndOpen,
            preloadReference: preloadReference,
            cancelPreload: cancelPreload
        };
    }, [
        load,
        onLoad
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
            }
            nodeRef.current = element;
        }
    }, [
        preloadReference,
        cancelPreload,
        addEventListener,
        cleanUpEventListeners
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return Object.assign(refCallback, {
        loadAndOpen: loadAndOpen
    });
}
module.exports["usePreloadRef"] = $c268b218f7087397$export$e0cecaf2b8cc8d36;

});

parcelRegister("l5XO6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

function $6e8d752af9ce8018$export$186b93979375b734({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const handleOpen = (0, $42omo.useCallback)(()=>{
        if (isOpen) onClose?.();
        else {
            if (openedByRef) openedByRef.current = 'click';
            onOpen();
        }
    }, [
        isOpen,
        onClose,
        openedByRef,
        onOpen
    ]);
    const keydownListener = (0, $42omo.useCallback)((event)=>{
        if (event instanceof KeyboardEvent && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            handleOpen();
        }
    }, [
        handleOpen
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) cleanUpEventListeners();
            if (element) {
                if (!isDisabled) addEventListener(element, 'click', handleOpen);
                addEventListener(element, 'keydown', keydownListener);
            }
            nodeRef.current = element;
        }
    }, [
        handleOpen,
        keydownListener,
        addEventListener,
        cleanUpEventListeners,
        isDisabled
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}
module.exports["usePressableTriggerRef"] = $6e8d752af9ce8018$export$186b93979375b734;

});

parcelRegister("lOr8f", function(module, exports) {
/* UserProfileCardTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

const $83ab1c124ccca6dc$var$styles = {
    trigger: "_kkk2n7od _1e0c1nu9"
};
const $83ab1c124ccca6dc$export$d5e867b0afea0b23 = ({ trigger: trigger, triggerProps: triggerProps, children: children })=>{
    const hoverOnlyTrigger = Array.isArray(trigger) ? trigger.every((mode)=>mode === 'hover') : trigger === 'hover';
    const useNonInteractiveHoverTrigger = hoverOnlyTrigger;
    if (useNonInteractiveHoverTrigger) {
        const { 'aria-expanded': _ariaExpanded, ...nonDialogTriggerProps } = triggerProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            ...nonDialogTriggerProps,
            testId: "user-profile-card-trigger-wrapper",
            xcss: $83ab1c124ccca6dc$var$styles.trigger
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        ...triggerProps,
        testId: "user-profile-card-trigger-wrapper",
        xcss: $83ab1c124ccca6dc$var$styles.trigger
    }, children);
};
module.exports["UserProfileCardTrigger"] = $83ab1c124ccca6dc$export$d5e867b0afea0b23;

});

parcelRegister("cQHTi", function(module, exports) {
/**
 * URL to the Atlassian support documentation for synced blocks in Confluence Cloud.
 */ const $7481da872fe5ea98$export$81b3a92cdfa3191b = 'https://support.atlassian.com/confluence-cloud/docs/reuse-content-with-synced-blocks';
module.exports["SYNCED_BLOCKS_DOCUMENTATION_URL"] = $7481da872fe5ea98$export$81b3a92cdfa3191b;

});

parcelRegister("9eOvr", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b2dbadf512f98f64$var$SyncBlockActionsContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $b2dbadf512f98f64$export$1536d3aa2f6b9cd9 = ()=>{
    return (0, $42omo.useContext)($b2dbadf512f98f64$var$SyncBlockActionsContext);
};
const $b2dbadf512f98f64$export$5f0b55764d1d819f = ({ children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo })=>{
    const value = (0, $42omo.useMemo)(()=>({
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        }), [
        removeSyncBlock,
        fetchSyncBlockSourceInfo
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b2dbadf512f98f64$var$SyncBlockActionsContext.Provider, {
        value: value
    }, children);
};
module.exports["useSyncBlockActions"] = $b2dbadf512f98f64$export$1536d3aa2f6b9cd9;
module.exports["SyncBlockActionsProvider"] = $b2dbadf512f98f64$export$5f0b55764d1d819f;

});

parcelRegister("lEQpi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hWRJP = parcelRequire("hWRJP");


var $ejAeh = parcelRequire("ejAeh");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $gtauf = parcelRequire("gtauf");


var $3RNNl = parcelRequire("3RNNl");


var $dBGrG = parcelRequire("dBGrG");

class $f2fbfd8272c84174$export$d353efb45bc662f4 {
    isSyncBlock(node) {
        return this.sourceSyncBlockStoreManager.isSourceBlock(node) || this.referenceSyncBlockStoreManager.isReferenceBlock(node);
    }
    async fetchReferencesSourceInfo(resourceId, blockInstanceId, isSourceSyncBlock) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchReferencesExperience?.start();
            const response = await this.dataProvider.fetchReferences(resourceId, isSourceSyncBlock);
            if (response.error) {
                this.fetchReferencesExperience?.failure({
                    reason: response.error
                });
                return {
                    error: response.error
                };
            }
            if (!response.references || response.references?.length === 0) return this.getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock);
            this.fetchReferencesExperience?.success();
            const sourceInfoPromises = (response.references ?? []).map(async (reference)=>{
                this.fetchSourceInfoExperience?.start();
                const sourceInfo = await this.dataProvider?.fetchSyncBlockSourceInfo(reference.blockInstanceId || '', reference.documentAri, (0, $ejAeh.getProductFromSourceAri)(reference.documentAri), reference.hasAccess);
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: `no source info returned for ari: ${reference.documentAri}`
                    });
                    return undefined;
                }
                this.fetchSourceInfoExperience?.success();
                return {
                    ...sourceInfo,
                    onSameDocument: reference.onSameDocument,
                    hasAccess: reference.hasAccess,
                    productType: sourceInfo.productType
                };
            });
            const sourceInfos = await Promise.all(sourceInfoPromises);
            const sourceSyncBlockData = await (isSourceSyncBlock ? this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId) : this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId));
            if (sourceSyncBlockData) sourceInfos.push({
                ...sourceSyncBlockData,
                onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
                hasAccess: true,
                isSource: true,
                productType: sourceSyncBlockData?.productType
            });
            return {
                references: sourceInfos
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.referenceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.sourceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.fetchReferencesExperience = (0, $QkKjT.getFetchReferencesExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
        this.fetchReferencesExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
    }
    async getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock) {
        // No reference found
        if (isSourceSyncBlock) {
            // Verify that a reference sync block for this specific source actually
            // exists on the current page by checking if the reference manager has
            // an active subscription for the derived reference resourceId.
            const referenceResourceId = this.referenceSyncBlockStoreManager.generateResourceIdForReference(resourceId);
            const hasUnregisteredReferenceOnPage = this.referenceSyncBlockStoreManager.getSubscribedResourceIds().includes(referenceResourceId);
            if (hasUnregisteredReferenceOnPage) {
                // This is current page data. It is the same for data for source and reference
                const sourceSyncBlockData = await this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId);
                const references = [];
                if (sourceSyncBlockData) {
                    const sourceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: true
                    };
                    const referenceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: false
                    };
                    references.push(sourceSyncBlockReference, referenceSyncBlockReference);
                }
                this.fetchReferencesExperience?.success();
                return {
                    references: references
                };
            }
            // No remote or local reference exists — show info text with link to doco on how to use Synced Blocks
            this.fetchReferencesExperience?.success();
            return {
                references: []
            };
        }
        // Though no references registered yet for this reference sync block,
        // still show the source and the current page itself since they are known
        // but not saved yet.
        const references = [];
        const sourceSyncBlockData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId);
        if (sourceSyncBlockData) references.push({
            ...sourceSyncBlockData,
            onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
            hasAccess: true,
            isSource: true
        });
        const currentPageData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfoByLocalId(blockInstanceId);
        if (currentPageData) references.push({
            ...currentPageData,
            onSameDocument: true,
            hasAccess: true,
            isSource: false
        });
        if (references.length === 0) {
            this.fetchReferencesExperience?.failure({
                reason: 'No references found for reference synced block'
            });
            return {
                error: (0, $awHlv.SyncBlockError).Errored
            };
        }
        this.fetchReferencesExperience?.success();
        return {
            references: references
        };
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.fetchReferencesExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        // In future, if reference manager needs to reach to source manager and read its current in memory cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $dBGrG.SourceSyncBlockStoreManager)(dataProvider, viewMode, isLivePage);
        this.referenceSyncBlockStoreManager = new (0, $3RNNl.ReferenceSyncBlockStoreManager)(dataProvider, viewMode);
        this.dataProvider = dataProvider;
        this.referenceSyncBlockStoreManager.setRealTimeSubscriptionsEnabled(true);
    }
}
const $f2fbfd8272c84174$var$createSyncBlockStoreManager = (dataProvider)=>{
    return new $f2fbfd8272c84174$export$d353efb45bc662f4(dataProvider);
};
const $f2fbfd8272c84174$export$d95b04bc16414394 = (dataProvider, fireAnalyticsEvent)=>{
    const syncBlockStoreManager = (0, $42omo.useMemo)(()=>{
        return $f2fbfd8272c84174$var$createSyncBlockStoreManager(dataProvider);
    }, [
        dataProvider
    ]);
    const prevFireAnalyticsEventRef = (0, $42omo.useRef)(undefined);
    if (fireAnalyticsEvent !== prevFireAnalyticsEventRef.current) {
        prevFireAnalyticsEventRef.current = fireAnalyticsEvent;
        syncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    }
    return syncBlockStoreManager;
};
module.exports["SyncBlockStoreManager"] = $f2fbfd8272c84174$export$d353efb45bc662f4;
module.exports["useMemoizedSyncBlockStoreManager"] = $f2fbfd8272c84174$export$d95b04bc16414394;

});

parcelRegister("QkKjT", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $grmt9 = parcelRequire("grmt9");

var $8kPu1 = parcelRequire("8kPu1");

var $fo9p3 = parcelRequire("fo9p3");

const $48856e1ef5d8a6d7$var$TIMEOUT_DURATION = 30000;
const $48856e1ef5d8a6d7$export$b335cfa3334e49e6 = (fireAnalyticsEvent)=>{
    return (payload)=>{
        // Runtime type guard - only forward experience events
        if (payload.action === (0, $d925B.ACTION).EXPERIENCE_MEASURED || payload.action === (0, $d925B.ACTION).EXPERIENCE_SAMPLED) fireAnalyticsEvent?.(payload);
    };
};
const $48856e1ef5d8a6d7$export$553df56755696c09 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$188e7890e84f55e4 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).REFERENCE_SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$cf32ad2bf7484097 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_GET_SOURCE_INFO,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$666920a07aaa7d43 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_DELETE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$bf943e4a2bda18f6 = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_CREATE,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $48856e1ef5d8a6d7$export$3ba8782eb93c9adf = (fireAnalyticsEvent)=>{
    return new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $d925B.ACTION).SYNCED_BLOCK_FETCH_REFERENCES,
        dispatchAnalyticsEvent: $48856e1ef5d8a6d7$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $48856e1ef5d8a6d7$var$TIMEOUT_DURATION
            })
        ]
    });
};
module.exports["getSaveSourceExperience"] = $48856e1ef5d8a6d7$export$553df56755696c09;
module.exports["getSaveReferenceExperience"] = $48856e1ef5d8a6d7$export$188e7890e84f55e4;
module.exports["getFetchExperience"] = $48856e1ef5d8a6d7$export$bbbbcdec37b3c0c0;
module.exports["getFetchSourceInfoExperience"] = $48856e1ef5d8a6d7$export$cf32ad2bf7484097;
module.exports["getDeleteSourceExperience"] = $48856e1ef5d8a6d7$export$666920a07aaa7d43;
module.exports["getCreateSourceExperience"] = $48856e1ef5d8a6d7$export$bf943e4a2bda18f6;
module.exports["getFetchReferencesExperience"] = $48856e1ef5d8a6d7$export$3ba8782eb93c9adf;

});

parcelRegister("3RNNl", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $4wATI = parcelRequire("4wATI");


var $gtauf = parcelRequire("gtauf");


var $dyHCj = parcelRequire("dyHCj");


var $bBz3A = parcelRequire("bBz3A");


var $cTANx = parcelRequire("cTANx");


var $axlAB = parcelRequire("axlAB");

const $bf9ff2ea047058dc$var$CACHE_KEY_PREFIX = 'sync-block-data-';
const $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_MAX_RETRIES = 3;
const $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS = 2000;
class $bf9ff2ea047058dc$export$fb04276dca31302e {
    isReferenceBlock(node) {
        return node.type.name === 'syncBlock';
    }
    /**
   * Enables or disables real-time GraphQL subscriptions for block updates.
   * When enabled, the store manager will subscribe to real-time updates
   * instead of relying on polling.
   * @param enabled - Whether to enable real-time subscriptions
   */ setRealTimeSubscriptionsEnabled(enabled) {
        this._subscriptionManager.setRealTimeSubscriptionsEnabled(enabled);
    }
    /**
   * Checks if real-time subscriptions are currently enabled.
   */ isRealTimeSubscriptionsEnabled() {
        return this._subscriptionManager.isRealTimeSubscriptionsEnabled();
    }
    /**
   * Returns all resource IDs that are currently subscribed to.
   * Used by React components to render subscription components.
   */ getSubscribedResourceIds() {
        return this._subscriptionManager.getSubscribedResourceIds();
    }
    /**
   * Registers a listener that will be called when subscriptions change.
   * @param listener - Callback function to invoke when subscriptions change
   * @returns Unsubscribe function to remove the listener
   */ onSubscriptionsChanged(listener) {
        return this._subscriptionManager.onSubscriptionsChanged(listener);
    }
    /**
   * Handles incoming data from a GraphQL subscription.
   * Called by React subscription components when they receive updates.
   * @param syncBlockInstance - The updated sync block instance
   */ handleSubscriptionUpdate(syncBlockInstance) {
        this._subscriptionManager.handleSubscriptionUpdate(syncBlockInstance);
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.fetchExperience = (0, $QkKjT.getFetchExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveReferenceExperience)(fireAnalyticsEvent);
    }
    setOnUnpublishedSyncBlockDetected(callback) {
        this.onUnpublishedSyncBlockDetected = callback;
    }
    /**
   * Mark a sync block as newly added to the document.
   * This should be called when a sync block node is added via a transaction.
   * @param resourceId - The resource ID of the newly added sync block
   */ markAsNewlyAdded(resourceId) {
        this.newlyAddedSyncBlocks.add(resourceId);
    }
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        const providerData = this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
        if (providerData) // Initial provider cache data can come from SSR/prefetch and bypass updateCache(),
        // so strip annotations here before references render existing synced block payloads.
        return this.stripAnnotationMarksFromReferenceData(providerData);
        return this.getFromSessionCache(resourceId);
    }
    stripAnnotationMarksFromReferenceData(syncBlock) {
        if (!syncBlock.data?.content) return syncBlock;
        const content = (0, $gtauf.stripAnnotationMarksFromJSONContent)(syncBlock.data.content);
        if (content === syncBlock.data.content) return syncBlock;
        return {
            ...syncBlock,
            data: {
                ...syncBlock.data,
                content: content
            }
        };
    }
    updateSessionCache(resourceId) {
        const latestData = this.getFromCache(resourceId);
        if (latestData) (0, $bBz3A.syncBlockInMemorySessionCache).setItem(`${$bf9ff2ea047058dc$var$CACHE_KEY_PREFIX}${resourceId}`, JSON.stringify(latestData));
    }
    getFromSessionCache(resourceId) {
        try {
            const raw = (0, $bBz3A.syncBlockInMemorySessionCache).getItem(`${$bf9ff2ea047058dc$var$CACHE_KEY_PREFIX}${resourceId}`);
            if (!raw) return undefined;
            // Session cache entries written before this sanitizer existed may still include
            // source annotation marks, so keep this read-time safety net for legacy data.
            return this.stripAnnotationMarksFromReferenceData(JSON.parse(raw));
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/getFromSessionCache'
            });
            return undefined;
        }
    }
    fetchSyncBlockSourceInfoBySourceAri(sourceAri, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const sourceInfo = this.dataProvider.fetchSyncBlockSourceInfo(undefined, sourceAri, undefined, hasAccess);
            return sourceInfo;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoBySourceAri'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfoByLocalId(localId, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined, hasAccess);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoByLocalId'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            if (!resourceId || !this.dataProvider) throw new Error('Data provider or resourceId not set');
            const existingRequest = this.syncBlockSourceInfoRequests.get(resourceId);
            if (existingRequest) return existingRequest;
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) throw new Error('No existing sync block to fetch source info for');
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId, sourceURL: sourceURL, sourceTitle: sourceTitle, onSameDocument: onSameDocument, sourceSubType: sourceSubType, issueType: issueType } = existingSyncBlock.data || {};
            // skip if source URL and title are already present
            if (sourceURL && sourceTitle) return Promise.resolve({
                title: sourceTitle,
                url: sourceURL,
                subType: sourceSubType,
                sourceAri: sourceAri || '',
                onSameDocument: onSameDocument,
                productType: product,
                issueType: issueType
            });
            // Derive once per call so we don't re-parse on every analytics event below.
            // `product` from cached data is preferred when available; fall back to parsing
            // the resourceId.
            const sourceProduct = product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId);
            if (!sourceAri || !product || !blockInstanceId) {
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing', resourceId, sourceProduct));
                return Promise.resolve(undefined);
            }
            this.fetchSourceInfoExperience?.start({});
            const sourceInfoPromise = this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, true // hasAccess
            ).then((sourceInfo)=>{
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'No source info returned'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('No source info returned', resourceId, sourceProduct));
                    return undefined;
                }
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this._subscriptionManager.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
                if (sourceInfo.title && sourceInfo.url) this.fetchSourceInfoExperience?.success();
                else {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'Missing title or url'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('Missing title or url', resourceId, sourceProduct));
                }
                return sourceInfo;
            }).catch((error)=>{
                this.fetchSourceInfoExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId, sourceProduct));
                return undefined;
            }).finally(()=>{
                this.syncBlockSourceInfoRequests.delete(resourceId);
            });
            this.syncBlockSourceInfoRequests.set(resourceId, sourceInfoPromise);
            return sourceInfoPromise;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        }
        return Promise.resolve(undefined);
    }
    /**
   * Processes prefetched data and updates the cache.
   * @param prefetchedData - The prefetched data to process
   * @returns {Promise<void>}
   */ async processPrefetchedData(prefetchedData) {
        if (!prefetchedData) return;
        // start the fetch experience (this should be started much earlier to properly track performance, but better late than never)
        this.fetchExperience?.start({});
        // mark the sync block requests as in fly
        prefetchedData.resourceIds.forEach((resourceId)=>{
            this.syncBlockFetchDataRequests.set(resourceId, true);
        });
        try {
            const prefetchedResolvedData = await prefetchedData.prefetchPromise;
            const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(prefetchedResolvedData);
            if (hasUnexpectedError) this.fetchExperience?.failure({
                reason: 'Unexpected error during prefetch'
            });
            else if (hasExpectedError) this.fetchExperience?.abort({
                reason: 'Expected error: NotFound or PermissionDenied during prefetch'
            });
            else this.fetchExperience?.success();
        } catch (error) {
            this.fetchExperience?.failure({
                reason: `Prefetch promise rejected: ${error.message}`
            });
        } finally{
            // Clean up in-flight markers so subsequent fetches are not blocked
            prefetchedData.resourceIds.forEach((resourceId)=>{
                this.syncBlockFetchDataRequests.delete(resourceId);
            });
        }
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return;
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [];
        syncBlockNodes.forEach((node)=>{
            if (this.syncBlockFetchDataRequests.get(node.attrs.resourceId)) return;
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error?.type === (0, $awHlv.SyncBlockError).NotFound) return;
            nodesToFetch.push(node);
        });
        if (nodesToFetch.length === 0) return;
        if (!this.dataProvider) throw new Error('Data provider not set');
        nodesToFetch.forEach((node)=>{
            this.syncBlockFetchDataRequests.set(node.attrs.resourceId, true);
        });
        this.fetchExperience?.start({});
        const data = await this.dataProvider.fetchNodesData(nodesToFetch).finally(()=>{
            nodesToFetch.forEach((node)=>{
                this.syncBlockFetchDataRequests.delete(node.attrs.resourceId);
            });
        });
        const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(data);
        if (hasUnexpectedError) this.fetchExperience?.failure({
            reason: 'Unexpected error during fetch'
        });
        else if (hasExpectedError) this.fetchExperience?.abort({
            reason: 'Expected error: NotFound or PermissionDenied'
        });
        else this.fetchExperience?.success();
    }
    processFetchedData(data) {
        if (!data) return {
            hasUnexpectedError: false,
            hasExpectedError: false
        };
        let hasUnexpectedError = false;
        let hasExpectedError = false;
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) {
                const payload = syncBlockInstance.error?.reason || syncBlockInstance.error?.type || 'Returned sync block instance does not have resource id';
                // No resourceId means we cannot derive a sourceProduct here; intentionally omit.
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(payload));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            // Check if this is a newly added unpublished sync block and notify
            // Only trigger for sync blocks that were just added (not refreshed or loaded on page init)
            if (!syncBlockInstance.error && resolvedSyncBlockInstance.data?.status === 'unpublished' && this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId) && this.onUnpublishedSyncBlockDetected) {
                // Remove from newly added set after checking to prevent duplicate flags
                this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
                this.onUnpublishedSyncBlockDetected(resolvedSyncBlockInstance.resourceId);
            } else if (this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId)) // Remove from newly added set even if not unpublished (to clean up)
            this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
            // Clear retry tracking on successful fetch — block has been created
            if (!syncBlockInstance.error && this.entityNotFoundRetryCount.has(syncBlockInstance.resourceId)) {
                const timer = this.entityNotFoundRetryTimers.get(syncBlockInstance.resourceId);
                if (timer) {
                    clearTimeout(timer);
                    this.entityNotFoundRetryTimers.delete(syncBlockInstance.resourceId);
                }
                this.entityNotFoundRetryCount.delete(syncBlockInstance.resourceId);
            }
            if (syncBlockInstance.error) {
                // Skip error analytics when EntityNotFound will be retried, to avoid
                // inflating error-rate metrics with expected transient failures
                const isRetryingEntityNotFound = syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).EntityNotFound && (this.entityNotFoundRetryCount.get(syncBlockInstance.resourceId) ?? 0) < $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_MAX_RETRIES && (0, $dh538.fg)('platform_synced_block_patch_13');
                if (!isRetryingEntityNotFound) this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error.reason || syncBlockInstance.error.type, syncBlockInstance.resourceId, syncBlockInstance.data?.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
                if (syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).NotFound || syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).Forbidden) hasExpectedError = true;
                else if (syncBlockInstance.error.type === (0, $awHlv.SyncBlockError).EntityNotFound) {
                    // Schedule a retry for EntityNotFound — the source block may be in
                    // the process of being created by a collaborator (race condition
                    // between NCS propagation and Block Service createBlock call).
                    if ((0, $dh538.fg)('platform_synced_block_patch_13')) this.scheduleEntityNotFoundRetry(syncBlockInstance.resourceId);
                    if (!isRetryingEntityNotFound) hasUnexpectedError = true;
                } else if (syncBlockInstance.error) hasUnexpectedError = true;
                return;
            }
            const callbacks = this._subscriptionManager.getSubscriptions().get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.fireAnalyticsEvent?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        return {
            hasUnexpectedError: hasUnexpectedError,
            hasExpectedError: hasExpectedError
        };
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title,
                onSameDocument: sourceInfo?.onSameDocument,
                sourceSubType: sourceInfo?.subType,
                issueType: sourceInfo?.issueType
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const sanitizedSyncBlock = this.stripAnnotationMarksFromReferenceData(syncBlock);
        const { resourceId: resourceId } = sanitizedSyncBlock;
        if (resourceId) {
            this.dataProvider?.updateCache({
                [resourceId]: sanitizedSyncBlock
            }, {
                strategy: 'merge',
                source: 'network'
            });
            this._subscriptionManager.notifySubscriptionCallbacks(resourceId, sanitizedSyncBlock);
            this.updateSessionCache(resourceId);
        }
    }
    getFromCache(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        return this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
    }
    deleteFromCache(resourceId) {
        this.dataProvider?.removeFromCache([
            resourceId
        ]);
        this._providerFactoryManager.deleteFactory(resourceId);
    }
    /**
   * Schedules a delayed retry for a block that returned EntityNotFound.
   * The block may be in the process of being created by a collaborator —
   * the NCS transaction propagates the bodiedSyncBlock ADF node before
   * the Block Service createBlock call completes.
   */ scheduleEntityNotFoundRetry(resourceId) {
        const currentRetries = this.entityNotFoundRetryCount.get(resourceId) ?? 0;
        if (currentRetries >= $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_MAX_RETRIES) // Max retries exceeded — keep count at max so future calls immediately exit
        // (don't delete — that would reset the counter and allow unbounded retry waves)
        return;
        // If a timer is already pending, don't schedule another one — let the
        // existing timer fire. This prevents rapid EntityNotFound responses from
        // exhausting the retry budget through cancellations without any actual
        // fetch completing.
        if (this.entityNotFoundRetryTimers.has(resourceId)) return;
        const delay = $bf9ff2ea047058dc$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS * Math.pow(2, currentRetries);
        const timer = setTimeout(()=>{
            this.entityNotFoundRetryTimers.delete(resourceId);
            // If no active subscriptions remain for this block, clean up and skip
            const subscriptions = this._subscriptionManager.getSubscriptions().get(resourceId);
            if (!subscriptions || Object.keys(subscriptions).length === 0) {
                this.entityNotFoundRetryCount.delete(resourceId);
                return;
            }
            // Increment count only when the timer fires, not when scheduled
            this.entityNotFoundRetryCount.set(resourceId, currentRetries + 1);
            // Clear the error from cache so fetchSyncBlocksData doesn't skip it
            const cached = this.getFromCache(resourceId);
            if (cached?.error?.type === (0, $awHlv.SyncBlockError).EntityNotFound) this.deleteFromCache(resourceId);
            // Trigger a re-fetch via the batch fetcher
            this.debouncedBatchedFetchSyncBlocks(resourceId);
        }, delay);
        this.entityNotFoundRetryTimers.set(resourceId, timer);
    }
    debouncedBatchedFetchSyncBlocks(resourceId) {
        this._batchFetcher.queueFetch(resourceId);
    }
    setSSRDataInSessionCache(resourceIds) {
        if (!resourceIds || resourceIds.length === 0) return;
        resourceIds.forEach((resourceId)=>{
            this.updateSessionCache(resourceId);
        });
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
    }
    subscribeToSourceTitle(node, callback) {
        return this._subscriptionManager.subscribeToSourceTitle(node, callback);
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock) return undefined;
        return syncBlock.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        return this._providerFactoryManager.getProviderFactory(resourceId);
    }
    getSSRProviders(resourceId) {
        return this._providerFactoryManager.getSSRProviders(resourceId);
    }
    /**
   * Update reference synced blocks on the document with the BE
   *
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (this.viewMode === 'view') return false;
        if (!this.isCacheDirty) // we use the isCacheDirty flag as a quick check.
        return true;
        // Prevent concurrent flushes to avoid race conditions with lastFlushedSyncedBlocks
        if (this.isFlushInProgress) {
            // Mark that another flush is needed after the current one completes
            this.flushNeededAfterCurrent = true;
            // We return true here because we know the pending flush will handle the dirty cache
            return true;
        } else this.isFlushInProgress = true;
        let success = true;
        // a copy of the subscriptions STRUCTURE (without the callbacks)
        // To be saved as the last flushed structure if the flush is successful
        const syncedBlocksToFlush = {};
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const blocks = [];
            // First, build the complete subscription structure
            for (const [resourceId, callbacks] of this._subscriptionManager.getSubscriptions().entries()){
                syncedBlocksToFlush[resourceId] = {};
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                    syncedBlocksToFlush[resourceId][localId] = true;
                });
            }
            // Then, compare with the last flushed structure to detect changes
            // We check against the last flushed structure to prevent unnecessary flushes
            // Note that we will always flush at least once when editor starts
            // This is useful for eventual consistency between the editor and the BE.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(syncedBlocksToFlush, this.lastFlushedSyncedBlocks)) {
                this.isCacheDirty = false; // Reset since we're considering this a successful no-op flush
                return true;
            }
            // reset isCacheDirty early to prevent race condition
            // There is a race condition where if a user makes changes (create/delete) to a reference sync block
            // on a live page and the reference sync block is being saved while the user
            // is still making changes, the new changes might not be saved if they all happen
            // exactly at a time when the updateReferenceData is being executed asynchronously.
            this.isCacheDirty = false;
            this.saveExperience?.start();
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                success = false;
                this.saveExperience?.failure({
                    reason: updateResult.error || 'Failed to update reference synced blocks on the document'
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document'));
            }
        } catch (error) {
            success = false;
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.saveExperience?.failure({
                reason: error.message
            });
            // No `resourceId` available in this catch — sourceProduct is intentionally omitted.
            this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(error.message));
        } finally{
            if (!success) // set isCacheDirty back to true for cases where it failed to update the reference synced blocks on the BE
            this.isCacheDirty = true;
            else {
                this.lastFlushedSyncedBlocks = syncedBlocksToFlush;
                this.saveExperience?.success();
            }
            // Always reset isFlushInProgress
            this.isFlushInProgress = false;
            // If another flush was requested while this one was in progress, execute it now
            if (this.flushNeededAfterCurrent) {
                this.flushNeededAfterCurrent = false;
                // Use setTimeout to avoid deep recursion and run queued flush asynchronously
                // Note: flush() handles all exceptions internally and never rejects
                this.queuedFlushTimeout = setTimeout(()=>{
                    this.queuedFlushTimeout = undefined;
                    this.flush();
                }, 0);
            }
        }
        return success;
    }
    destroy() {
        // Cancel any queued flush to prevent it from running after destroy
        if (this.queuedFlushTimeout) {
            clearTimeout(this.queuedFlushTimeout);
            this.queuedFlushTimeout = undefined;
        }
        // Cancel any pending EntityNotFound retry timers
        this.entityNotFoundRetryTimers.forEach((timer)=>clearTimeout(timer));
        this.entityNotFoundRetryTimers.clear();
        this.entityNotFoundRetryCount.clear();
        this._subscriptionManager.destroy();
        this._providerFactoryManager.destroy();
        this._batchFetcher.destroy();
        this.dataProvider?.resetCache();
        this.dataProvider = undefined;
        this.syncBlockFetchDataRequests.clear();
        this.syncBlockSourceInfoRequests.clear();
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fireAnalyticsEvent = undefined;
        (0, $bBz3A.syncBlockInMemorySessionCache).clear();
    }
    constructor(dataProvider, viewMode){
        this.viewMode = void 0;
        this.dataProvider = void 0;
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor session is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockFetchDataRequests = void 0;
        this.syncBlockSourceInfoRequests = void 0;
        // Track newly added sync blocks (resourceIds that were just subscribed to without cached data)
        this.newlyAddedSyncBlocks = void 0;
        // Keep track of the last flushed subscriptions to optimize cache flushing on document save
        this.lastFlushedSyncedBlocks = {};
        // Callback to notify when an unpublished sync block is detected
        this.onUnpublishedSyncBlockDetected = void 0;
        // Track if a flush operation is currently in progress
        this.isFlushInProgress = false;
        // Track if another flush is needed after the current one completes
        this.flushNeededAfterCurrent = false;
        // Track the setTimeout handle for queued flush so we can cancel it on destroy
        this.queuedFlushTimeout = void 0;
        // Track retry attempts for EntityNotFound errors (block may be in the process of being created)
        this.entityNotFoundRetryCount = new Map();
        this.entityNotFoundRetryTimers = new Map();
        this.fetchExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.saveExperience = void 0;
        this._subscriptionManager = void 0;
        this._providerFactoryManager = void 0;
        this._batchFetcher = void 0;
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.syncBlockFetchDataRequests = new Map();
        this.syncBlockSourceInfoRequests = new Map();
        this.newlyAddedSyncBlocks = new Set();
        this._subscriptionManager = new (0, $axlAB.SyncBlockSubscriptionManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            updateCache: (inst)=>this.updateCache(inst),
            deleteFromCache: (rid)=>this.deleteFromCache(rid),
            debouncedBatchedFetchSyncBlocks: (rid)=>this.debouncedBatchedFetchSyncBlocks(rid),
            fetchSyncBlockSourceInfo: (rid)=>this.fetchSyncBlockSourceInfo(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            markCacheDirty: ()=>{
                this.isCacheDirty = true;
            }
        });
        this._providerFactoryManager = new (0, $cTANx.SyncBlockProviderFactoryManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        this._batchFetcher = new (0, $dyHCj.SyncBlockBatchFetcher)({
            getSubscriptions: ()=>this._subscriptionManager.getSubscriptions(),
            fetchSyncBlocksData: (nodes)=>this.fetchSyncBlocksData(nodes),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        // The provider might have SSR data cache already set, so we need to update the cache in session memory storage
        this.setSSRDataInSessionCache(this.dataProvider?.getNodeDataCacheKeys());
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $bf9ff2ea047058dc$export$fb04276dca31302e;

});

parcelRegister("4wATI", function(module, exports) {

var $f8eu7 = parcelRequire("f8eu7");


var $awHlv = parcelRequire("awHlv");

const $165aef3c3dcb8be4$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (newResult.error?.type === (0, $awHlv.SyncBlockError).NotFound || newResult.error?.type === (0, $awHlv.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined,
            sourceSubType: $165aef3c3dcb8be4$var$mergeSubType(oldResult, newResult),
            onSameDocument: newResult.data?.onSameDocument || oldResult.data?.onSameDocument || undefined,
            issueType: newResult.data?.issueType || oldResult.data?.issueType || undefined
        }
    };
};
const $165aef3c3dcb8be4$var$mergeSubType = (oldResult, newResult)=>{
    // for classic pages, subType is 'null'
    if (newResult.data?.sourceSubType !== undefined) return newResult.data.sourceSubType;
    if (newResult.data?.sourceAri) // for blogposts, subType is always undefined
    try {
        const { type: pageType } = (0, $f8eu7.getPageIdAndTypeFromConfluencePageAri)({
            ari: newResult.data?.sourceAri
        });
        if (pageType === 'blogpost') return newResult.data?.sourceSubType;
    } catch  {}
    return oldResult.data?.sourceSubType;
};
module.exports["resolveSyncBlockInstance"] = $165aef3c3dcb8be4$export$dcc459f28c1cd2fd;

});

parcelRegister("dyHCj", function(module, exports) {

var $2P8Ax = parcelRequire("2P8Ax");


var $hWRJP = parcelRequire("hWRJP");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

class $f5bf878eca9bbfe8$export$7d827e0357659116 {
    queueFetch(resourceId) {
        const subscriptions = this.deps.getSubscriptions();
        if (subscriptions.has(resourceId) && Object.keys(subscriptions.get(resourceId) || {}).length > 0) {
            this.pendingFetchRequests.add(resourceId);
            this.scheduledBatchFetch();
        } else this.pendingFetchRequests.delete(resourceId);
    }
    cancel() {
        this.scheduledBatchFetch.cancel();
    }
    clearPending() {
        this.pendingFetchRequests.clear();
    }
    destroy() {
        this.cancel();
        this.clearPending();
    }
    constructor(deps){
        this.deps = deps;
        this.pendingFetchRequests = new Set();
        this.scheduledBatchFetch = void 0;
        this.scheduledBatchFetch = (0, $2P8Ax.default)(()=>{
            if (this.pendingFetchRequests.size === 0) return;
            const resourceIds = Array.from(this.pendingFetchRequests);
            const syncBlockNodes = resourceIds.map((resId)=>{
                const subscriptions = this.deps.getSubscriptions().get(resId) || {};
                const firstLocalId = Object.keys(subscriptions)[0] || '';
                return (0, $gtauf.createSyncBlockNode)(firstLocalId, resId);
            });
            this.pendingFetchRequests.clear();
            this.deps.fetchSyncBlocksData(syncBlockNodes).catch((error)=>{
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockBatchFetcher/batchedFetchSyncBlocks'
                });
                resourceIds.forEach((resId)=>{
                    this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resId)));
                });
            });
        });
    }
}
module.exports["SyncBlockBatchFetcher"] = $f5bf878eca9bbfe8$export$7d827e0357659116;

});

parcelRegister("bBz3A", function(module, exports) {
/**
 * In-memory session cache for sync block data with size-based LRU eviction.
 *
 * Backed by a plain Map so that potentially private ADF content is never
 * written to any browser-persistent storage (sessionStorage, localStorage,
 * IndexedDB). The module-level singleton survives SPA transitions (no full
 * page reload) and is naturally cleared on hard navigation or tab close.
 *
 * Uses JavaScript Map's insertion-order guarantee to implement LRU:
 * on every read or write the accessed entry is moved to the end of the
 * iteration order; when total cached size exceeds `maxSize`, the oldest
 * (least-recently-used) entries are evicted first.
 */ class $657a090a5274b259$export$75f7f86498dcaabe {
    /**
   * Retrieves a cached value by key.
   *
   * **Side-effect:** promotes the entry to the most-recently-used
   * position by re-inserting it at the end of the underlying Map's
   * iteration order.
   */ getItem(key) {
        const value = this.store.get(key);
        if (value === undefined) return null;
        this.store.delete(key);
        this.store.set(key, value);
        return value;
    }
    setItem(key, value) {
        const existing = this.store.get(key);
        if (existing !== undefined) {
            this.currentSize -= existing.length;
            this.store.delete(key);
        }
        this.store.set(key, value);
        this.currentSize += value.length;
        while(this.currentSize > this.maxSize && this.store.size > 1){
            const oldestKey = this.store.keys().next().value;
            if (oldestKey !== undefined) {
                const oldestValue = this.store.get(oldestKey);
                if (oldestValue !== undefined) this.currentSize -= oldestValue.length;
                this.store.delete(oldestKey);
            }
        }
    }
    removeItem(key) {
        const value = this.store.get(key);
        if (value !== undefined) {
            this.currentSize -= value.length;
            this.store.delete(key);
        }
    }
    /**
   * Removes all entries from the cache and resets the tracked size to zero.
   * Useful for cleaning up the singleton on SPA navigation boundaries.
   */ clear() {
        this.store.clear();
        this.currentSize = 0;
    }
    constructor(maxSize = 5242880){
        this.store = new Map();
        this.currentSize = 0;
        /**
     * Maximum total size of all cached values, measured in **UTF-16 code
     * units** (i.e. `String.prototype.length`), not bytes.  For ASCII-only
     * content the two are equivalent; for content with characters outside
     * the BMP each surrogate pair counts as 2.
     */ this.maxSize = void 0;
        this.maxSize = maxSize;
    }
}
const $657a090a5274b259$export$b811313deafee9ed = new $657a090a5274b259$export$75f7f86498dcaabe();
module.exports["syncBlockInMemorySessionCache"] = $657a090a5274b259$export$b811313deafee9ed;

});

parcelRegister("cTANx", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $4FxUL = parcelRequire("4FxUL");


var $cFpEg = parcelRequire("cFpEg");


var $47N43 = parcelRequire("47N43");


var $gtauf = parcelRequire("gtauf");

class $acb948bac57fc60c$export$3bfff6c128de82c9 {
    getProviderFactory(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) {
            const error = new Error('Data provider not set');
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            return undefined;
        }
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            providerFactory = (0, $4FxUL.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        } else {
            if (parentDataProviders?.mentionProvider) providerFactory.setProvider('mentionProvider', parentDataProviders?.mentionProvider);
            if (parentDataProviders?.profilecardProvider) providerFactory.setProvider('profilecardProvider', parentDataProviders?.profilecardProvider);
            if (parentDataProviders?.taskDecisionProvider) providerFactory.setProvider('taskDecisionProvider', parentDataProviders?.taskDecisionProvider);
        }
        if (providerCreator) try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        }
        return providerFactory;
    }
    getSSRProviders(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) return null;
        const { providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        if (!providerCreator?.createSSRMediaProvider) return null;
        const parsedResourceId = (0, $47N43.parseResourceId)(resourceId);
        if (!parsedResourceId) return null;
        let { contentId: contentId, product: contentProduct } = parsedResourceId;
        const syncBlock = this.deps.getFromCache(resourceId);
        let contentAri = syncBlock?.data?.sourceAri || '';
        if (syncBlock?.data?.sourceAri && syncBlock.data.product) {
            const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
            if (parentInfo) {
                contentId = parentInfo.contentId;
                contentProduct = parentInfo.contentProduct;
                contentAri = parentInfo.contentAri;
            }
        }
        try {
            const mediaProvider = providerCreator.createSSRMediaProvider({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct
            });
            if (mediaProvider) return {
                media: mediaProvider
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
        }
        return null;
    }
    deleteFactory(resourceId) {
        this.providerFactories.delete(resourceId);
    }
    destroy() {
        this.providerFactories.forEach((pf)=>pf.destroy());
        this.providerFactories.clear();
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        const hasCardProvider = providerFactory.hasProvider('cardProvider');
        if (hasMediaProvider && hasEmojiProvider && hasCardProvider) return;
        const syncBlock = this.deps.getFromCache(resourceId);
        if (!syncBlock?.data) return;
        if (!syncBlock.data.sourceAri || !syncBlock.data.product) {
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)('Sync block source ari or product not found', resourceId, // Prefer cached product when available; fall back to parsing resourceId.
            syncBlock.data.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            return;
        }
        const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
        if (!parentInfo) throw new Error('Unable to retrieve sync block parent info');
        const { contentAri: contentAri, contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider && providerCreator.createMediaProvider && contentId && contentProduct) {
            const mediaProvider = providerCreator.createMediaProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
        }
        if (!hasEmojiProvider && providerCreator.createEmojiProvider && contentId && contentProduct) {
            const emojiProvider = providerCreator.createEmojiProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
        }
        if (!hasCardProvider && providerCreator.createSmartLinkProvider) {
            const smartLinkProvider = providerCreator.createSmartLinkProvider();
            if (smartLinkProvider) providerFactory.setProvider('cardProvider', smartLinkProvider);
        }
    }
    constructor(deps){
        this.deps = deps;
        this.providerFactories = new Map();
    }
}
module.exports["SyncBlockProviderFactoryManager"] = $acb948bac57fc60c$export$3bfff6c128de82c9;

});

parcelRegister("axlAB", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $cFpEg = parcelRequire("cFpEg");


var $4wATI = parcelRequire("4wATI");


var $gtauf = parcelRequire("gtauf");

class $e3afe1feb1dd429f$export$200c87d47b3d6e17 {
    /**
   * Returns the subscriptions map. Used by external consumers (e.g. batch fetcher, flush)
   * that need to read the current subscription state.
   */ getSubscriptions() {
        return this.subscriptions;
    }
    setRealTimeSubscriptionsEnabled(enabled) {
        if (this.useRealTimeSubscriptions === enabled) return;
        this.useRealTimeSubscriptions = enabled;
        if (enabled) this.setupSubscriptionsForAllBlocks();
        else this.cleanupAll();
    }
    isRealTimeSubscriptionsEnabled() {
        return this.useRealTimeSubscriptions;
    }
    getSubscribedResourceIds() {
        return Array.from(this.subscriptions.keys());
    }
    onSubscriptionsChanged(listener) {
        this.subscriptionChangeListeners.add(listener);
        return ()=>{
            this.subscriptionChangeListeners.delete(listener);
        };
    }
    notifySubscriptionChangeListeners() {
        this.subscriptionChangeListeners.forEach((listener)=>{
            try {
                listener();
            } catch (error) {
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockSubscriptionManager/notifySubscriptionChangeListeners'
                });
                this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message));
            }
        });
    }
    handleSubscriptionUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $4wATI.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // Cancel any pending cache deletion for this resourceId.
        // This handles the case where a block is moved - the old component unmounts
        // (scheduling deletion) but the new component mounts and subscribes before
        // the deletion timeout fires.
        const pendingDeletion = this.pendingCacheDeletions.get(resourceId);
        if (pendingDeletion) {
            clearTimeout(pendingDeletion);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        const isNewResourceSubscription = Object.keys(resourceSubscriptions).length === 0;
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.deps.markCacheDirty();
        // Notify listeners if this is a new resource subscription
        if (isNewResourceSubscription) this.notifySubscriptionChangeListeners();
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData) callback(cachedData);
        else this.deps.debouncedBatchedFetchSyncBlocks(resourceId);
        // Set up GraphQL subscription if real-time subscriptions are enabled
        if (this.shouldUseRealTime()) this.setupSubscription(resourceId);
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.deps.markCacheDirty();
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) {
                    this.subscriptions.delete(resourceId);
                    // Clean up GraphQL subscription when no more local subscribers
                    this.cleanupSubscription(resourceId);
                    // Notify listeners that subscription was removed
                    this.notifySubscriptionChangeListeners();
                    // Delay cache deletion to handle block moves (unmount/remount).
                    // When a block is moved, the old component unmounts before the new one mounts.
                    // By delaying deletion, we give the new component time to subscribe and
                    // cancel this pending deletion, preserving the cached data.
                    // TODO: EDITOR-4152 - Rework this logic
                    const deletionTimeout = setTimeout(()=>{
                        // Only delete if still no subscribers (wasn't re-subscribed)
                        if (!this.subscriptions.has(resourceId)) this.deps.deleteFromCache(resourceId);
                        this.pendingCacheDeletions.delete(resourceId);
                    }, 1000);
                    this.pendingCacheDeletions.set(resourceId, deletionTimeout);
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    /**
   * Notifies all subscription callbacks for a given resource ID with the provided sync block instance.
   */ notifySubscriptionCallbacks(resourceId, syncBlock) {
        const callbacks = this.subscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(syncBlock);
        });
    }
    setupSubscription(resourceId) {
        if (this.graphqlSubscriptions.has(resourceId)) return;
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider?.subscribeToBlockUpdates) return;
        const unsubscribe = dataProvider.subscribeToBlockUpdates(resourceId, (syncBlockInstance)=>{
            this.handleGraphQLUpdate(syncBlockInstance);
        }, (error)=>{
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/graphql-subscription'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            this.handleSubscriptionTerminated(resourceId);
        }, ()=>{
            this.handleSubscriptionTerminated(resourceId);
        });
        if (unsubscribe) this.graphqlSubscriptions.set(resourceId, unsubscribe);
    }
    /**
   * Handles subscription termination (complete or error) by cleaning up the
   * stale entry and scheduling a reconnection with exponential backoff.
   */ handleSubscriptionTerminated(resourceId) {
        // Remove the stale subscription entry so setupSubscription won't early-return
        this.graphqlSubscriptions.delete(resourceId);
        // Guard against duplicate calls (graphql-ws can fire both error and complete)
        if (this.pendingRetries.has(resourceId)) return;
        // Only reconnect if there are still active subscribers for this resource
        if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) this.scheduleReconnection(resourceId);
    }
    /**
   * Schedules a reconnection attempt with exponential backoff.
   * Delay = INITIAL_RETRY_DELAY_MS * (RETRY_BACKOFF_MULTIPLIER ^ attempts)
   * e.g. 1s, 2s, 4s, 8s, 16s
   */ scheduleReconnection(resourceId) {
        const attempts = this.retryAttempts.get(resourceId) ?? 0;
        if (attempts >= $e3afe1feb1dd429f$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS) {
            const errorMessage = `Subscription reconnection failed after ${attempts} attempts`;
            (0, $hWRJP.logException)(new Error(errorMessage), {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/max-retries-exhausted'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(errorMessage, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            return;
        }
        const delay = $e3afe1feb1dd429f$export$200c87d47b3d6e17.INITIAL_RETRY_DELAY_MS * Math.pow($e3afe1feb1dd429f$export$200c87d47b3d6e17.RETRY_BACKOFF_MULTIPLIER, attempts);
        const timer = setTimeout(()=>{
            this.pendingRetries.delete(resourceId);
            // Only re-subscribe if still relevant
            if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) {
                this.setupSubscription(resourceId);
                // Only increment if the subscription was actually established
                // (setupSubscription may be a no-op if another code path already re-established it)
                if (this.graphqlSubscriptions.has(resourceId)) this.retryAttempts.set(resourceId, attempts + 1);
            } else // Conditions no longer met — clean up stale retry state
            this.retryAttempts.delete(resourceId);
        }, delay);
        this.pendingRetries.set(resourceId, timer);
    }
    /**
   * Resets the retry counter for a resource. Called when a successful
   * update is received, indicating the subscription is healthy.
   */ resetRetryCount(resourceId) {
        this.retryAttempts.delete(resourceId);
    }
    cancelPendingRetry(resourceId) {
        const timer = this.pendingRetries.get(resourceId);
        if (timer) {
            clearTimeout(timer);
            this.pendingRetries.delete(resourceId);
        }
    }
    cancelAllPendingRetries() {
        for (const timer of this.pendingRetries.values())clearTimeout(timer);
        this.pendingRetries.clear();
        this.retryAttempts.clear();
    }
    cleanupSubscription(resourceId) {
        const unsubscribe = this.graphqlSubscriptions.get(resourceId);
        if (unsubscribe) {
            unsubscribe();
            this.graphqlSubscriptions.delete(resourceId);
        }
        this.cancelPendingRetry(resourceId);
        this.retryAttempts.delete(resourceId);
    }
    setupSubscriptionsForAllBlocks() {
        for (const resourceId of this.subscriptions.keys())this.setupSubscription(resourceId);
    }
    cleanupAll() {
        for (const unsubscribe of this.graphqlSubscriptions.values())unsubscribe();
        this.graphqlSubscriptions.clear();
        this.cancelAllPendingRetries();
    }
    destroy() {
        this.cleanupAll();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.subscriptionChangeListeners.clear();
        this.useRealTimeSubscriptions = false;
        // Clear any pending cache deletions
        for (const timeout of this.pendingCacheDeletions.values())clearTimeout(timeout);
        this.pendingCacheDeletions.clear();
    }
    shouldUseRealTime() {
        return this.useRealTimeSubscriptions;
    }
    handleGraphQLUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $4wATI.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) {
            this.resetRetryCount(syncBlockInstance.resourceId);
            const callbacks = this.subscriptions.get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
        } else {
            const errorMessage = syncBlockInstance.error?.reason || syncBlockInstance.error?.type;
            this.deps.getFireAnalyticsEvent()?.((0, $cFpEg.fetchErrorPayload)(errorMessage, syncBlockInstance.resourceId, syncBlockInstance.data?.product ?? (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
        }
    }
    constructor(deps){
        this.deps = deps;
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.graphqlSubscriptions = new Map();
        this.subscriptionChangeListeners = new Set();
        this.useRealTimeSubscriptions = false;
        // Track pending cache deletions to handle block moves (unmount/remount)
        // When a block is moved, the old component unmounts before the new one mounts,
        // causing the cache to be deleted prematurely. We delay deletion to allow
        // the new component to subscribe and cancel the pending deletion.
        this.pendingCacheDeletions = new Map();
        this.retryAttempts = new Map();
        this.pendingRetries = new Map();
    }
}
// Reconnection with exponential backoff
$e3afe1feb1dd429f$export$200c87d47b3d6e17.INITIAL_RETRY_DELAY_MS = 1000;
$e3afe1feb1dd429f$export$200c87d47b3d6e17.RETRY_BACKOFF_MULTIPLIER = 2;
$e3afe1feb1dd429f$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS = 5;
module.exports["SyncBlockSubscriptionManager"] = $e3afe1feb1dd429f$export$200c87d47b3d6e17;

});

parcelRegister("dBGrG", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $QkKjT = parcelRequire("QkKjT");


var $gtauf = parcelRequire("gtauf");

/** Maximum time (ms) flush() will wait for in-flight block creations before proceeding. */ const $297b92badcfd6d6a$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS = 1000;
class $297b92badcfd6d6a$export$9c6faa8962092f36 {
    /**
   * Register a callback to be invoked after flush() completes.
   * Used by the pm-plugin to dispatch a transaction so that
   * hasUnsavedBodiedSyncBlockChanges is recalculated in plugin state.
   */ registerFlushCompletionCallback(callback) {
        this.flushCompletionCallback = callback;
    }
    /**
   * Register a callback to be invoked when flush() timed out waiting for a
   * pending block creation and that creation subsequently completes. The
   * callback should trigger a deferred flush to persist the content that
   * was skipped due to the timeout. See EDITOR-7112.
   */ registerPostCreationFlushCallback(callback) {
        this.postCreationFlushCallback = callback;
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.createExperience = (0, $QkKjT.getCreateSourceExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $QkKjT.getSaveSourceExperience)(fireAnalyticsEvent);
        this.deleteExperience = (0, $QkKjT.getDeleteSourceExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $QkKjT.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode, isRemote) {
        try {
            if (this.viewMode === 'view') return false;
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) throw new Error('Local ID or resource ID is not set');
            const cachedBlock = this.syncBlockCache.get(resourceId);
            // Fast path: if the PM content fragment hasn't changed, skip serialization entirely
            // Fragment.eq() leverages ProseMirror's structural sharing for O(1) comparison
            if (cachedBlock?.contentFragment?.eq(syncBlockNode.content)) return true;
            const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
            if (cachedBlock && !isRemote) this.hasReceivedContentChange = true;
            const isDirty = !isRemote || !cachedBlock; // if the change is not remote, or the block is not in the cache yet, it's dirty
            this.syncBlockCache.set(resourceId, {
                ...syncBlockData,
                isDirty: isDirty,
                // if the change is from remote, it's not dirty
                contentFragment: syncBlockNode.content,
                status: cachedBlock?.status
            });
            return true;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // We can derive the product from `syncBlockNode.attrs.resourceId` even though
            // the variable wasn't destructured (the destructuring step itself may have thrown).
            this.fireAnalyticsEvent?.((0, $cFpEg.updateCacheErrorPayload)(error.message, syncBlockNode?.attrs?.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(syncBlockNode?.attrs?.resourceId)));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            if (this.viewMode === 'view') return true;
            // Wait (up to FLUSH_CREATION_AWAIT_TIMEOUT_MS) for any in-flight
            // block creations to complete before iterating the cache. Without
            // this, blocks created from existing content are skipped
            // (isPendingCreation check below) and if no further edits are made,
            // no subsequent flush is triggered — causing references to show an
            // "unpublished" error.
            // If the timeout expires, any block whose creation is still
            // in-flight is recorded in `creationsTimedOutDuringFlush` so that
            // `commitPendingCreation()` can trigger a follow-up flush once that
            // specific creation completes.
            // See EDITOR-7112.
            if (this.pendingCreationPromises.size > 0) {
                let timedOut = false;
                let timeoutId;
                const timeout = new Promise((resolve)=>{
                    timeoutId = setTimeout(()=>{
                        timedOut = true;
                        resolve();
                    }, $297b92badcfd6d6a$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS);
                });
                await Promise.race([
                    Promise.all(this.pendingCreationPromises.values()),
                    timeout
                ]);
                if (timeoutId !== undefined) clearTimeout(timeoutId);
                if (timedOut) // Record every still-in-flight creation so each late
                // completion is tracked independently.
                for (const resourceId of this.pendingCreationPromises.keys())this.creationsTimedOutDuringFlush.add(resourceId);
            }
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that
                // - are waiting to be deleted to avoid nodes being re-created
                // - haven't been updated since we last flushed
                // - are still pending BE creation
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty && !this.isPendingCreation(syncBlockData.resourceId)) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    // reset isDirty early to prevent race condition
                    // There is a race condition where if a user makes changes to a source sync block
                    // on a live page and the source sync block is being saved while the user
                    // is still making changes, the new changes might not be saved if they all happen
                    // exactly at a time when the writeNodesData is being executed asynchronously.
                    syncBlockData.isDirty = false;
                    // When flushing, set status to 'active' so the block is published
                    const dataToFlush = {
                        ...syncBlockData,
                        status: 'active'
                    };
                    bodiedSyncBlockData.push(dataToFlush);
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.saveExperience?.start({});
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to true for cases where it failed to save the sync block to the BE
                if (result.resourceId && result.error && result.error !== (0, $awHlv.SyncBlockError).NotFound) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) cachedData.isDirty = true;
                }
            });
            if (writeResults.every((result)=>result.resourceId && !result.error)) {
                this.saveExperience?.success();
                writeResults.forEach((result)=>{
                    if (result.resourceId && !result.error) {
                        // Update cache with the status returned from the backend
                        const cachedData = this.syncBlockCache.get(result.resourceId);
                        if (cachedData && result.status) cachedData.status = result.status;
                        this.fireAnalyticsEvent?.((0, $cFpEg.updateSuccessPayload)(result.resourceId, false, (0, $gtauf.getSourceProductFromResourceIdSafe)(result.resourceId)));
                    }
                });
                return true;
            } else {
                this.saveExperience?.failure();
                writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(result.error || 'Failed to write data', result.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(result.resourceId)));
                });
                return false;
            }
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // Top-level flush failure is not tied to a single resourceId.
            this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(error.message));
            return false;
        } finally{
            this.flushCompletionCallback?.();
        }
    }
    hasUnsavedChanges() {
        if (this.viewMode === 'view') return false;
        // Only track unsaved changes in source synced block for live pages
        // classic pages's draft don't publish synced block content to block service and the content itself is saved as part of the draft
        // classic page's publish flow will trigger a flush which only uses the isDirty flag to determine if there are unsaved changes
        if (!this.isLivePage) return false;
        return this.hasReceivedContentChange && Array.from(this.syncBlockCache.values()).some((syncBlockData)=>syncBlockData.isDirty);
    }
    isPendingCreation(resourceId) {
        return this.creationCompletionCallbacks.has(resourceId);
    }
    /**
   * Returns `true` when at least one sync block is waiting for its backend
   * creation call to complete. Used as a cheap pre-check in the decoration
   * rebuild path to avoid a full `doc.descendants()` walk when no creations
   * are in flight (see EDITOR-6930).
   */ hasPendingCreations() {
        return this.creationCompletionCallbacks.size > 0;
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success, resourceId) {
        if (this.viewMode === 'view') return;
        const onCompletion = this.creationCompletionCallbacks.get(resourceId);
        if (onCompletion) {
            this.creationCompletionCallbacks.delete(resourceId);
            onCompletion(success);
            // If a previous flush() timed out waiting for this specific
            // creation, drop it from the tracking set regardless of outcome so
            // it does not leak. See EDITOR-7112.
            const wasTimedOut = this.creationsTimedOutDuringFlush.delete(resourceId);
            if (success) {
                // If creation is successful, set hasReceivedContentChange to true
                // to indicate that there are unsaved changes in the cache
                this.hasReceivedContentChange = true;
                // If flush() timed out waiting for this creation, notify the
                // plugin so it can trigger a deferred flush. See EDITOR-7112.
                if (wasTimedOut) this.postCreationFlushCallback?.();
            }
        } else this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)('creation complete callback missing', resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        if (success) this.fireAnalyticsEvent?.((0, $cFpEg.createSuccessPayload)(resourceId || '', (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        else {
            // Delete the node from cache if fail to create so it's not flushed to BE
            this.syncBlockCache.delete(resourceId || '');
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)('Fail to create bodied sync block', resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        }
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        if (!this.dataProvider) throw new Error('Data provider not set or source id not set');
        const { resourceId: resourceId, localId: localId } = this.dataProvider.generateResourceId();
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   * @param node the ProseMirror node to cache
   * @param onCompletion callback invoked when creation completes
   */ createBodiedSyncBlockNode(attrs, node, onCompletion) {
        if (this.viewMode === 'view') return;
        const { resourceId: resourceId, localId: blockInstanceId } = attrs;
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            // add the node to the cache
            this.updateSyncBlockData(node, false);
            // Mark the block as unpublished in the cache so it can be cleaned up on cancel
            const cached = this.syncBlockCache.get(resourceId);
            if (cached) cached.status = 'unpublished';
            this.creationCompletionCallbacks.set(resourceId, onCompletion);
            this.createExperience?.start({});
            const creationPromise = this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId || '';
                if (resourceId && !result.error) {
                    this.commitPendingCreation(true, resourceId);
                    this.createExperience?.success();
                } else {
                    this.commitPendingCreation(false, resourceId);
                    this.createExperience?.failure({
                        reason: result.error || 'Failed to create bodied sync block'
                    });
                    this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(result.error || 'Failed to create bodied sync block', resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
                }
            }).catch((error)=>{
                this.commitPendingCreation(false, resourceId);
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                this.createExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            }).finally(()=>{
                this.pendingCreationPromises.delete(resourceId);
            });
            this.pendingCreationPromises.set(resourceId, creationPromise);
        } catch (error) {
            if (this.isPendingCreation(resourceId)) this.commitPendingCreation(false, resourceId);
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
        }
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted, reason) {
        try {
            if (this.viewMode === 'view') return false;
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            this.deleteExperience?.start({});
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId), reason);
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                onDelete();
                callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                this.clearPendingDeletion();
                this.deleteExperience?.success();
                results.forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(result.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(result.resourceId)));
                });
            } else {
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                this.deleteExperience?.failure();
                results.forEach((result)=>{
                    if (result.success) this.fireAnalyticsEvent?.((0, $cFpEg.deleteSuccessPayload)(result.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(result.resourceId)));
                    else this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(result.error || 'Failed to delete synced block', result.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(result.resourceId)));
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, false);
                this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(error.message, Ids.resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(Ids.resourceId)));
            });
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (this.viewMode === 'view') return Promise.resolve();
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted, deletionReason: deletionReason } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason);
    }
    clearPendingDeletion() {
        this.deletionRetryInfo?.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   * Fetches the current status of all source sync blocks in the cache from the backend
   * and updates the cache entries with the fetched status.
   * This is called on editor init so we know which blocks are 'unpublished' vs 'active'.
   */ async fetchAndCacheStatuses() {
        if (!this.dataProvider || this.syncBlockCache.size === 0) return;
        // Source blocks have plain UUID resourceIds, but fetchNodesData internally uses
        // generateBlockAriFromReference which expects reference-format resourceIds
        // (e.g. "confluence-page/pageId/uuid"). We convert source resourceIds to reference
        // format before fetching, and maintain a mapping back to original resourceIds
        // so we can update the correct cache entries.
        const sourceToReferenceMap = new Map();
        const syncBlockNodes = Array.from(this.syncBlockCache.entries()).map(([resourceId, data])=>{
            const referenceResourceId = this.dataProvider?.generateResourceIdForReference(resourceId) ?? resourceId;
            sourceToReferenceMap.set(referenceResourceId, resourceId);
            return {
                type: 'bodiedSyncBlock',
                attrs: {
                    localId: data.blockInstanceId,
                    resourceId: referenceResourceId
                }
            };
        });
        try {
            const results = await this.dataProvider.fetchNodesData(syncBlockNodes);
            for (const result of results){
                // Map the reference resourceId back to the source resourceId
                const sourceResourceId = sourceToReferenceMap.get(result.resourceId) ?? result.resourceId;
                const cached = this.syncBlockCache.get(sourceResourceId);
                if (cached && result.data?.status) cached.status = result.data.status;
            }
        } catch  {
        // If the fetch fails, statuses remain undefined.
        // This is acceptable — on cancel, blocks without a known status
        // will not be deleted (safe default).
        }
    }
    /**
   * Deletes all source sync blocks that have 'unpublished' status.
   * Used to clean up orphaned blocks when a user cancels editing without saving.
   * Blocks that were already saved (status 'active') are not affected.
   *
   * @returns true if all deletions succeeded, false otherwise
   */ discardUnpublishedBlocks() {
        const unpublishedBlockIds = Array.from(this.syncBlockCache.entries()).filter(([_, data])=>data.status === 'unpublished' && !data.pendingDeletion).map(([resourceId, data])=>({
                resourceId: resourceId,
                localId: data.blockInstanceId
            }));
        if (unpublishedBlockIds.length === 0) return Promise.resolve(true);
        return this.delete(unpublishedBlockIds, ()=>{}, // onDelete: no-op, document is being discarded
        ()=>{}, // onDeleteCompleted: no-op
        'source-block-unpublished');
    }
    /**
   * Deletes sync blocks with confirmation from the backend
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, deletionReason, onDelete, onDeleteCompleted, destroyCallback) {
        if (this.viewMode === 'view') return Promise.resolve();
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds, deletionReason);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback,
                    deletionReason: deletionReason
                };
                else destroyCallback();
            } else destroyCallback();
        }
    }
    getSyncBlockSourceInfo(localId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchSourceInfoExperience?.start();
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined).then((sourceInfo)=>{
                if (!sourceInfo) this.fetchSourceInfoExperience?.failure({
                    reason: 'No source info returned'
                });
                else this.fetchSourceInfoExperience?.success();
                return sourceInfo;
            });
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchReferences(resourceId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchReferences(resourceId, true);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchReferencesErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            return Promise.resolve({
                error: (0, $awHlv.SyncBlockError).Errored
            });
        }
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.creationCompletionCallbacks.clear();
        this.flushCompletionCallback = undefined;
        this.postCreationFlushCallback = undefined;
        this.pendingCreationPromises.clear();
        this.creationsTimedOutDuringFlush.clear();
        this.dataProvider = undefined;
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.createExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.deleteExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.clearPendingDeletion();
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.viewMode = void 0;
        this.isLivePage = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockCache = void 0;
        this.hasReceivedContentChange = false;
        this.confirmationCallback = void 0;
        this.deletionRetryInfo = void 0;
        this.creationCompletionCallbacks = void 0;
        this.flushCompletionCallback = void 0;
        this.postCreationFlushCallback = void 0;
        /**
     * Promises for in-flight block creations, keyed by resourceId.
     * `flush()` awaits these so that blocks created from existing content are
     * persisted even if no further edits trigger a subsequent flush.
     * See EDITOR-7112.
     */ this.pendingCreationPromises = new Map();
        /**
     * Set of resource IDs whose creation was still in-flight when a `flush()`
     * timed out. Each completion (success or failure) is removed from this set;
     * the first successful completion of any of these IDs triggers
     * `postCreationFlushCallback` so the content is eventually persisted.
     * Tracking IDs (not just a boolean) avoids dropping late completions when
     * multiple blocks are created concurrently. See EDITOR-7112.
     */ this.creationsTimedOutDuringFlush = new Set();
        this.createExperience = void 0;
        this.saveExperience = void 0;
        this.deleteExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.setPendingDeletion = (Ids, value)=>{
            if (this.viewMode === 'view') return;
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.isLivePage = isLivePage;
        this.syncBlockCache = new Map();
        this.creationCompletionCallbacks = new Map();
    }
}
module.exports["SourceSyncBlockStoreManager"] = $297b92badcfd6d6a$export$9c6faa8962092f36;

});

parcelRegister("a7tZV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $hWRJP = parcelRequire("hWRJP");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

const $fb1e42d9cacf5d6e$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    // Initialize both states from a single cache lookup to avoid race conditions.
    // When a block is moved/remounted, the old component's cleanup may clear the cache
    // before or after the new component mounts. By doing a single lookup, we ensure
    // consistency between syncBlockInstance and isLoading initial values.
    const [{ syncBlockInstance: syncBlockInstance, isLoading: isLoading }, setFetchState] = (0, $42omo.useState)(()=>{
        if (resourceId) {
            const initialData = manager?.referenceManager?.getInitialSyncBlockData(resourceId);
            return {
                syncBlockInstance: initialData ?? null,
                isLoading: initialData === undefined
            };
        }
        return {
            syncBlockInstance: null,
            isLoading: true
        };
    });
    const reloadData = (0, $42omo.useCallback)(async ()=>{
        if (isLoading) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $gtauf.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setFetchState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message, resourceId, (0, $gtauf.getSourceProductFromResourceIdSafe)(resourceId)));
            // Set error state if fetching fails
            setFetchState({
                syncBlockInstance: {
                    resourceId: resourceId || '',
                    error: {
                        type: (0, $awHlv.SyncBlockError).Errored
                    }
                },
                isLoading: false
            });
            return;
        }
        setFetchState((prev)=>({
                ...prev,
                isLoading: false
            }));
    }, [
        isLoading,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $eTj7Y.isSSR)()) // in SSR, we don't need to subscribe to updates,
        // instead we rely on pre-fetched data ONLY, see initialization of syncBlockInstance above
        return;
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setFetchState({
                syncBlockInstance: data,
                isLoading: false
            });
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        localId,
        manager.referenceManager,
        resourceId
    ]);
    const ssrProviders = (0, $42omo.useMemo)(()=>{
        return resourceId ? manager.referenceManager.getSSRProviders(resourceId) : null;
    }, [
        resourceId,
        manager.referenceManager
    ]);
    return {
        isLoading: isLoading,
        ssrProviders: ssrProviders,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $fb1e42d9cacf5d6e$export$2b02427d5640395b;

});


$parcel$global.rlb("6vHwB")
//# sourceMappingURL=CommentEditor.edd7bbaf.js.map
